import _ from "lodash";
import React from "react";
import ACLStore from "lib/aclStore";
import { getIsUniversalParentEnabled } from "Utils/ACLStoreUtils";
import {
  SubsectionListOutlined,
  LeOutlined,
  FaOutlined,
  SaOutlined,
  AssessmentAddOutlined,
  WorksheetClipboardOutlined,
  LinkOutlined,
  NoteOutlined,
  UploadOutlined,
  GoogleDriveColored,
  OneDriveColored,
  DeviceDesktopOutlined,
  SectionListOutlined,
  AiOutlined,
  UnitPlanOutlined,
  PencilLineOutlined,
  // UserCloseOutlined,
  ShareCurveOutlined,
  CaretOpenedFilled,
  CaretClosedFilled,
  DeleteOutlined,
  AddToLibraryOutlined,
  DownloadOutlined,
  CopyOutlined,
  SyncCompleteOutlined,
  // LinkSimpleHorizontalOutlined,
  PrintOutlined,
  TextTOutlined,
  ImportOutlined,
  JournalOutlined,
  ClassProgressOutlined,
  OpenBookTextOutlined,
  LeLibraryOutlined,
  SwitchArrowsOutlined,
  MarkAsReadOutlined,
  UserTickOutlined,
  TickCircleOutlined,
  ReloadArrowOutlined,
  TickCircleOpenOutlined,
  PageFoldPortraitOutlined,
  LockOpenOutlined,
  LockFilled,
  EyeOutlined,
  DashedCircleOutlined,
  QuickTaskOutlined,
  DashedCircleMinusOutlined,
  SyncPendingOutlined,
  AddOutlined,
  DashboardOutlined,
  AssessmentOutlined,
  DotsHorizontalOutlined,
} from "@toddle-edu/ds-icons";
import { Avatar } from "@toddle-edu/ds-web";
import { fontStyles } from "@toddle-edu/ds-theme";
import classes from "CourseFlow/components/CourseFlow.scss";
import {
  ENABLE_ASSESSMENTS_IN_PYP,
  ENABLE_AI_TUTOR,
  OPEN_AND_CREATE_ASSIGNMENTS_IN_EDIT_MODE,
  CAN_ASSIGN_COURSE_CONTENT_PERMISSION,
  ENABLE_GRADE_WISE_ASSESSMENT,
} from "Constants/permissionConstants";
import { ASSESSMENT_TYPE_WORKSHEET } from "Worksheet/modules/WorksheetConstants";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CREATE_AI_TUTOR,
  ASSESSMENT_TYPE_AI_TUTOR,
  SUBJECT_TYPE_EE,
} from "Constants/stringConstants";
import {
  getMemoizedFunction,
  getMemoizedLangFunction,
  isUserTypeStaff,
  isUserTypeParent,
  isUserTypeStudent,
} from "Utils";
import { isAITutorMarketingEnabled } from "Platform/modules/PlatformUtils";
import {
  MAX_DEPTH_FOR_COURSE_FLOW,
  MAX_FOLDER_DEPTH_FOR_COURSE_FLOW,
} from "UIComponents/NestedAccordion/constants";
import {
  isFolder,
  isUnitPlan,
  SCHEDULE,
  splitAssessmentAndResourceTypesMemoized,
} from "Utils/EntityFlowUtils";
import { getGroupOrAssessmentTypes } from "AppComponents/Gradebook/modules/GradebookGraphqlHelpers";
import { getAssessmentTemplatesFromCache } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import {
  getIsAssessmentTypeConfigurationEnabled,
  getIsImportFromClassFlowInCoursePlanEnabled,
  getIsAITutorInEEEnabled,
} from "Utils/ACLStoreUtils";
import { getTaskTypeAvatarName } from "Utils/EntityFlowUtils";
import {
  getSelectedLearningCourseId,
  CARD_VIEW,
  TIMELINE_VIEW,
  COURSE_OVERVIEW,
  isClassModuleVisible,
  SYNC_STATUS,
} from "LearningCourse/modules/Utils";
import { getCourseFlowItemFromCache } from "./CourseFlowGraphqlHelpers";
import {
  getCreateUnitDropdownConfig,
  getIsProSchool,
} from "UnitPlans/modules/Utils";
import { getFormattedStudentName } from "Utils/GetFormattedStudentName";
import {
  getCurrentCurriculumProgramType,
  getSelectedCourseId,
} from "modules/CommonSelectors";
import { getUserInfo } from "Login/modules/LoginModule";
import {
  PUBLISHED_STUDENT_ASSIGNMENT_STATUS,
  PUBLISHED_STUDENT_ASSIGNMENT_LOCKING_SUBMISSION_STATUS,
  ASSIGNMENT_STATE_TABS,
} from "ClassRoom/modules/ClassRoomModule/ClassRoomConstants";
import { getArchivedStudentAssignmentStatus } from "ClassRoom/modules/ClassRoomModule/ClassRoomUtils";
import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";
import { isSchoolLibraryEnabled } from "SchoolLibrary/modules/Utils";
import {
  CARD,
  getIsBlueprintSyncHistoryV2Enabled,
  getIsSyncAndLockAllowed,
  TABLE,
  TIMELINE,
} from "LearningCourse/modules/LearningCourseUtils";
import { isToddleLibraryEnabled } from "ToddleLibrary/modules/ToddleLibraryUtils";

export const LE_FEED_STYLES = {
  feedInnerContainerStyle: {
    width: "100%",
    margin: "0 auto",
  },
  headerContainerStyle: {
    padding: "32px 32px 20px",
    width: "100%",
    margin: "0 auto",
  },
  feedContainerStyle: {
    alignItems: "center",
    padding: "0 20px 0 32px",
  },
  customNonSelectedContainerStyle: {
    borderRadius: "8px",
  },
  customSelectedContainerStyle: {
    borderRadius: "8px",
  },
  moreFiltersBarStyle: {
    marginTop: "12px",
  },
  titleTextStyle: {
    margin: 0,
    flexShrink: 0,
  },
  imageContainerStyle: {
    height: "72px",
    width: "72px",
    minWidth: "72px",
  },
  feedItemTitleStyle: {
    fontSize: "1.6rem",
    ...fontStyles.demiBold,
    marginBottom: 0,
  },
  staffDetailsStyle: {
    marginTop: "12px",
  },
  staffNameStyle: {
    ...fontStyles.medium,
    fontSize: "1.2rem",
  },
  feedDataListContainerStyle: {
    height: "100px",
  },
  headerTabContainerStyle: {
    marginBottom: 0,
  },
  customSearchBarStyle: {
    display: "flex",
    maxWidth: "320px",
    gap: "24px",
    alignItems: "center",
  },
  profileImageContainerProps: {
    size: "x-small",
    className: classes.profileImageContainerClass,
  },
  displayCountHeadingWithSearch: true,
};

const getDepthWiseSectionOptions = ({ depth, isModule, isAncestorUnit }) => {
  // this option is only available for sections
  // it creates a new section at same level of current section after its children
  const parallelSectionOption = {
    label: "classMaterials:add_section",
    key: "create_parallel_section",
    icon: <SectionListOutlined />,
  };

  const sectionOption = {
    label: "classMaterials:add_section",
    key: "create_section",
    icon: <SectionListOutlined />,
  };

  const subsectionOption = {
    label: "classMaterials:add_subsection",
    key: "create_subsection",
    icon: <SubsectionListOutlined />,
  };

  let maxFolderDepth = MAX_FOLDER_DEPTH_FOR_COURSE_FLOW;
  let maxDepth = MAX_DEPTH_FOR_COURSE_FLOW;
  if (isFolder && !isAncestorUnit) {
    maxFolderDepth--;
    maxDepth--;
  }

  /* 'depth' here denotes the depth at which the new item will be createdAt
   * if 'isModule' is true, that means the trigger element is a section
   * 'isCollapsed' is true then the folder element is 1 level above depth, otherwise same level
   */

  /**
   * Depth 1
   * Can only create sections
   */

  if (depth === 1) {
    return [sectionOption];
  }

  /**
   * Depth 2
   * Files:
   ** Can only create sections under files
   *
   * Folders:
   ** Section + subsection
   */

  if (depth === 2) {
    if (isModule) {
      return [subsectionOption];
    }

    return [sectionOption];
  }

  /**
   * Depth above 2 till max folder depth
   * Files:
   ** Can only create sections below files
   *
   * Folders:
   ** Both parallel and subsections can be created
   */
  if (_.inRange(depth, 3, maxDepth)) {
    if (isModule) {
      return [parallelSectionOption, subsectionOption];
    }

    return [sectionOption];
  }

  // Restrict sections above max folder depth
  if (depth > maxFolderDepth && !isModule) {
    return [];
  }

  // Can create a parallel section at max folder depth
  if (depth === maxDepth && isModule) {
    return [parallelSectionOption];
  }

  return [];
};

export const canCreateAssessmentInEditMode = () =>
  ACLStore.can(OPEN_AND_CREATE_ASSIGNMENTS_IN_EDIT_MODE);

export const getWrapperFieldName = () => {
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  const isUserTeacher = isUserTypeStaff({ userType });

  return isUserTeacher
    ? "learningCourseFlowFeedWrapper"
    : "classFlowFeedWrapper";
};

export const getCourseFlowFeed = data => {
  return _.get(
    data,
    `node.${getWrapperFieldName()}.learningCourseFlowFeed`,
    {}
  );
};

export const getCourseFlowOutlineFeed = data =>
  _.get(
    data,
    `node.${getWrapperFieldName()}.learningCourseFlowFeedOutline`,
    []
  );

// memoized as it can cause re-renders
export const getCourseFlowNodesMemoized = getMemoizedFunction(data => {
  return _.map(data, "node");
});

export const getCourseFlowFeedQueryVariables = ({ state }) => {
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  const isUserTeacher = isUserTypeStaff({ userType });

  const isUserParent = isUserTypeParent({ userType });

  const isUserStudent = isUserTypeStudent({ userType });

  const selectedCourseId = getSelectedCourseId(state);

  const id = isUserTeacher
    ? getSelectedLearningCourseId(state)
    : selectedCourseId;

  const curriculumType = getCurrentCurriculumProgramType(state);

  const filtersInState = _.get(state, "courseFlow.filters", {});
  const courseFlowFilters = _.mapValues(filtersInState, (value, key) => {
    const isAllOption = _.isEqual(value, "ALL") && key != "searchText";
    return isAllOption ? [] : value;
  });

  const {
    searchText = "",
    unitType = [],
    students = [],
    contentTypes = [],
    subjects = [],
    classes = [],
    studentAssignmentStatus = [],
    taskTypeIds = [],
  } = courseFlowFilters;

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  let assessmentFilters = {};

  if (isAssessmentTypeConfigurationEnabled) {
    // When FF is enabled, use taskTypeIds directly
    assessmentFilters = {
      taskTypeIds,
      studentAssignmentStatus,
    };
  } else {
    // Original logic when FF is disabled
    const {
      selectedAssessmentTypes,
      selectedResourceTypes,
    } = splitAssessmentAndResourceTypesMemoized({
      selectedItemTypes: contentTypes,
    });

    const { assessmentTypes = [], groupTypes = [] } = getGroupOrAssessmentTypes(
      {
        curriculumType,
        selectedAssessmentTypes,
      }
    );

    assessmentFilters = {
      assessmentType: assessmentTypes,
      groupTypes,
      studentAssignmentStatus,
    };
  }

  // Get resource types for attachmentTypes filter
  const { selectedResourceTypes } = splitAssessmentAndResourceTypesMemoized({
    selectedItemTypes: contentTypes,
  });

  const filters = {
    searchText,
    unitTypes: unitType,
    sharedWith: students,
    itemTypes: ["FOLDER", "ASSESSMENT", "UNIT_PLAN", "FILE"],
    classIds: classes,
    subjects,
    assessmentFilters,
    attachmentTypes: selectedResourceTypes,
  };

  if (isUserParent) {
    filters.studentIds = [userInfo.childID];
  }

  if (!isUserTeacher && !_.isEmpty(selectedCourseId)) {
    filters.classIds = [selectedCourseId];
  }

  return {
    id,
    filters,
    syncedBluePrintItemFilters: {
      learningCourseId: id,
    },
    type: isUserTeacher ? "LEARNING_COURSE" : "COURSE",
    assessmentAssignmentsFilters:
      userType !== "staff"
        ? {
            courseIds: [selectedCourseId],
          }
        : undefined,
    skipAssignedStudents: userType === "staff",
    studentIds: isUserStudent
      ? [userInfo.id]
      : isUserParent
      ? [userInfo.childID]
      : undefined,
    stateFilters: {
      classIds: classes,
    },
  };
};

export const getCourseFlowOutlineQueryVariables = ({ state }) => {
  const feedVariables = getCourseFlowFeedQueryVariables({
    state,
  });

  const isUniversalParentEnabled = getIsUniversalParentEnabled();
  if (!isUniversalParentEnabled) return feedVariables;

  return {
    ...feedVariables,
    filters: {
      ...feedVariables.filters,
      includeAllItemTypes: true,
    },
  };
};

export const getIsImportFromToddleLibraryEnabled = () => {
  return ACLStore.can("FeatureFlag:ImportFromToddleLibraryInCoursePlan");
};

const getIsImportUnitFromAnotherCourseEnabled = () => {
  return ACLStore.can("FeatureFlag:ImportUnitFromAnotherCourse");
};

/**
 * This function receives data in old format of course flow and returns it in
 * class flow format so that common components across course-flow, unit-flow and class-flow
 * can be reused
 */
export const getUpdatedCourseFlowStructure = ({
  feedData,
  selectedClass = null,
}) => {
  return _.map(feedData, node => {
    const childrenV2 = _.get(node, "childrenV2", []);

    const hasAttachment = _.get(node, "item.__typename") === "Attachment";
    const attachment = _.get(node, "item");

    const updatedAttachment = hasAttachment
      ? {
          ...attachment,
          type: attachment.attachmentType,
          title: attachment.attachmentTitle,
        }
      : null;

    let sharedDetails = _.get(node, "sharedDetails", []);
    if (selectedClass) {
      const selectedClassId = _.get(selectedClass, "id", null);
      sharedDetails = _.filter(
        sharedDetails,
        cls => cls?.class?.id === selectedClassId
      );
    }

    return {
      ...node,
      sharedDetails,
      childrenV2: { edges: _.map(childrenV2, child => ({ node: child })) },
      attachment: updatedAttachment,
    };
  });
};

export const getResourceData = ({ item, variables }) => {
  const {
    id,
    depth,
    parent,
    label,
    resourceType,
    childrenHierarchyInfo,
    isSyncedWithAllTeacherCourse,
  } = item;
  const childFeedData = getCourseFlowItemFromCache({
    id,
    variables,
  });

  const isUnitInProgress =
    isUnitPlan({ resourceType }) &&
    _.get(childFeedData, "item.state") === "IN_PROGRESS";

  if (!_.isEmpty(childFeedData) && !isUnitInProgress) {
    return { ...childFeedData, depth, childrenHierarchyInfo };
  }

  return {
    ...item,
    id,
    label,
    displaySequence: 1,
    depth,
    resourceType,
    isSkeleton: true,
    parent,
    childrenHierarchyInfo: null,
    childrenV2: [],
    lockingInfo: null,
    isSyncedWithAllTeacherCourse,
    __typename: "LearningCourseFlow",
  };
};

const getSingleUnitTemplateKey = options => {
  if (_.size(options) !== 1) return null;
  const only = _.first(options);
  if (only.isItemGroup || only.disabled) return null;
  return only.key;
};

const buildCreateUnitOption = ({
  t,
  isTermExistsForCurrentLearningCourse,
  createUnitDropDownOptions,
}) => {
  const singleTemplateKey = getSingleUnitTemplateKey(createUnitDropDownOptions);
  const base = {
    label: "common:unit",
    icon: <UnitPlanOutlined />,
    disabled: !isTermExistsForCurrentLearningCourse,
    disabledTooltip: t(
      "classRoom:import_from_label_no_grading_periods_tooltip",
      { label: t("common:unit_lowercase") }
    ),
  };
  return singleTemplateKey
    ? { ...base, key: singleTemplateKey }
    : {
        ...base,
        key: "CREATE_UNIT",
        isSubMenu: true,
        options: createUnitDropDownOptions,
      };
};

export const getAddDropDownOptions = ({
  t,
  isRoot,
  curriculumType,
  depth,
  isModule,
  isFolder,
  isUnit,
  isAncestorUnit,
  hideAssessments = false,
  unitTypeOptions,
  plannerTemplates,
  currentCourseViewType,
  isCourseBasedGradingEnabled,
  isTermExistsForCurrentLearningCourse,
  learningCourseSubjects = [],
  isUnlockedTermExistsForCurrentLearningCourse = true,
  learningCourseSubjectType,
  isClassFlowEnabledInAnyAY = false,
  baseCurriculum,
}) => {
  const isPYPAssessmentEnabled = ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP);
  const isUnitOnlyFeed = _.includes(
    [CARD, TIMELINE, TABLE, CARD_VIEW, TIMELINE_VIEW, COURSE_OVERVIEW],
    currentCourseViewType
  );
  const isScheduleView = _.includes([SCHEDULE], currentCourseViewType);
  const isImportFromClassFlowEnabled = getIsImportFromClassFlowInCoursePlanEnabled();
  const anotherCourseKey = isImportFromClassFlowEnabled
    ? "IMPORT_FROM_ANOTHER_COURSE_CLASS_FLOW"
    : "IMPORT_FROM_ANOTHER_COURSE";
  const anotherCourseLabel =
    isImportFromClassFlowEnabled && isClassFlowEnabledInAnyAY
      ? "course:another_course_class_flow"
      : "course:another_course";

  const canCreateAssessments = _.includes(
    [
      CURRICULUM_TYPE_DP,
      CURRICULUM_TYPE_MYP,
      ...(isPYPAssessmentEnabled ? [CURRICULUM_TYPE_PYP] : []),
    ],
    curriculumType
  );

  const canCreateWorksheets = ACLStore.can("FeatureFlag:ClassroomWorksheet");
  const canCreateAIChatTask =
    ACLStore.can(ENABLE_AI_TUTOR) || isAITutorMarketingEnabled();
  const isMapleBearLikeOrg = ACLStore.can("FeatureFlag:IsMapleBearLikeOrg");
  const showSchoolLibraryOption = isSchoolLibraryEnabled();
  const showToddleLibraryOption = isToddleLibraryEnabled();

  const SUBJECT_TYPES_TO_EXCLUDE_FROM_LIBRARY = ["EE", "CAS"];
  const shouldHideLibraryOptions =
    _.isEqual(curriculumType, CURRICULUM_TYPE_DP) &&
    _.some(learningCourseSubjects, subject =>
      _.includes(SUBJECT_TYPES_TO_EXCLUDE_FROM_LIBRARY, _.get(subject, "type"))
    );

  const { createUnitDropDownOptions } = getCreateUnitDropdownConfig({
    unitTypeOptions,
    plannerTemplates,
    hideImportOptions: true,
    isCourseBasedGradingEnabled,
    isLearningCoursesEnabled: true,
    curriculumType,
    learningCourseSubjects,
  });

  const isImportFromToddleLibrary = getIsImportFromToddleLibraryEnabled();
  const isImportUnitFromAnotherCourse = getIsImportUnitFromAnotherCourseEnabled();

  const baseCurriculumImportOption = baseCurriculum && {
    key: "import_from_base_library",
    label: baseCurriculum.label,
    isLabelLocalized: true,
    icon: <OpenBookTextOutlined />,
    disabled:
      !isTermExistsForCurrentLearningCourse ||
      !isUnlockedTermExistsForCurrentLearningCourse,
    disabledTooltip: !isTermExistsForCurrentLearningCourse
      ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
          label: t("course:course"),
        })
      : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
  };

  const createUnitOptions = [
    buildCreateUnitOption({
      t,
      isTermExistsForCurrentLearningCourse,
      createUnitDropDownOptions,
    }),
  ];

  const createAITutorOption = {
    label: "common:ai_tutor",
    key: CREATE_AI_TUTOR,
    value: ASSESSMENT_TYPE_AI_TUTOR,
    icon: <AiOutlined />,
    disabled:
      !isTermExistsForCurrentLearningCourse ||
      !isUnlockedTermExistsForCurrentLearningCourse,
    disabledTooltip: !isTermExistsForCurrentLearningCourse
      ? t(
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
          { label: t("common:ai_tutor") }
        )
      : t("course:item_cannot_be_added_due_to_locked_grading_periods"),
  };

  if (isUnitOnlyFeed) {
    const importOpts = _.compact([
      isImportUnitFromAnotherCourse && {
        key: "IMPORT_FROM_ANOTHER_COURSE",
        label: "course:another_course",
        icon: <ClassProgressOutlined />,
        disabled:
          !isTermExistsForCurrentLearningCourse ||
          !isUnlockedTermExistsForCurrentLearningCourse,
        disabledTooltip: !isTermExistsForCurrentLearningCourse
          ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
              label: t("course:course"),
            })
          : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
      },
      showSchoolLibraryOption && {
        key: "IMPORT_UNIT_FROM_LIBRARY",
        disabled:
          !isTermExistsForCurrentLearningCourse ||
          !isUnlockedTermExistsForCurrentLearningCourse,
        disabledTooltip: !isTermExistsForCurrentLearningCourse
          ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
              label: t("course:course"),
            })
          : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
        label: "common:school_library",
        icon: <OpenBookTextOutlined />,
      },
      isImportFromToddleLibrary &&
        showToddleLibraryOption && {
          key: "IMPORT_UNIT_FROM_TODDLE_LIBRARY",
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
          label: "common:toddle_library_lowercase",
          icon: <JournalOutlined />,
        },
      baseCurriculumImportOption,
    ]);

    return _.compact([
      isRoot &&
        _.size(createUnitDropDownOptions) && {
          label: "common:create",
          key: "CREATE",
          isItemGroup: true,
          options: createUnitOptions,
        },
      {
        label: "common:import_from",
        key: "import_menu",
        isItemGroup: true,
        icon: <ImportOutlined />,
        options: importOpts,
      },
    ]);
  }

  let importMenu;
  if (isImportFromToddleLibrary && showToddleLibraryOption) {
    importMenu = {
      label: "common:import_from",
      key: "import_menu",
      isItemGroup: true,
      icon: <ImportOutlined />,
      options: _.compact([
        isRoot && {
          key: anotherCourseKey,
          label: anotherCourseLabel,
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        showSchoolLibraryOption && {
          key: "SCHOOL_LIBRARY",
          label: "common:school_library",
          icon: <OpenBookTextOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:school_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
          isSubMenu: true,
          options: _.compact([
            isRoot &&
              !shouldHideLibraryOptions && {
                key: "IMPORT_UNIT_FROM_LIBRARY",
                label: "common:unit",
                icon: <OpenBookTextOutlined />,
              },
            {
              key: "IMPORT_LE_FROM_LE_LIBRARY",
              label: "common:le_and_assessments",
              icon: <LeLibraryOutlined />,
            },
          ]),
        },
        !isMapleBearLikeOrg &&
          ((isRoot && !shouldHideLibraryOptions) || !hideAssessments) && {
            key: "TODDLE_LIBRARY",
            label: "common:toddle_library_lowercase",
            icon: <JournalOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:toddle_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
            isSubMenu: true,
            options: _.compact([
              isRoot &&
                !shouldHideLibraryOptions && {
                  key: "IMPORT_UNIT_FROM_TODDLE_LIBRARY",
                  label: "common:unit",
                  icon: <OpenBookTextOutlined />,
                },
              !hideAssessments && {
                key: "IMPORT_FROM_TODDLE_LIBRARY",
                label: "common:le_and_assessments",
                icon: <LeLibraryOutlined />,
              },
            ]),
          },
        isRoot && !shouldHideLibraryOptions && baseCurriculumImportOption,
      ]),
    };
  } else {
    importMenu = {
      label: "common:import_from",
      key: "import_menu",
      isSubMenu: true,
      icon: <ImportOutlined />,
      options: _.compact([
        isRoot && {
          key: anotherCourseKey,
          label: anotherCourseLabel,
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isRoot &&
          showSchoolLibraryOption &&
          !shouldHideLibraryOptions && {
            key: "IMPORT_UNIT_FROM_LIBRARY",
            label: "common:school_library",
            icon: <OpenBookTextOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:school_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
          },
        showSchoolLibraryOption && {
          key: "IMPORT_LE_FROM_LE_LIBRARY",
          label: "common:learning_experience_and_assessment_library",
          icon: <LeLibraryOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:learning_experience_and_assessment_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isRoot && !shouldHideLibraryOptions && baseCurriculumImportOption,
      ]),
    };
  }

  const isScheduleViewOptions = [
    {
      label: "common:add_content_from",
      key: "ADD_CONTENT_FROM",
      isSubMenu: true,
      showDivider: false,
      icon: <AddOutlined />,
      options: [
        {
          key: "ADD_FROM_COURSE_FLOW",
          label: "course:course_flow",
          icon: <DashboardOutlined />,
        },
        {
          key: "ADD_FROM_CLASS_ASSIGNMENTS",
          label: "classRoom:class_assignments",
          icon: <AssessmentOutlined />,
        },
      ],
    },
    {
      label: "common:import_from",
      key: "import_menu",
      isSubMenu: true,
      icon: <ImportOutlined />,
      options: _.compact([
        {
          key: "IMPORT_FROM_ANOTHER_COURSE",
          label: "course:another_course",
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        showSchoolLibraryOption && {
          key: "IMPORT_FROM_SCHOOL_LIBRARY",
          label: "common:school_library",
          icon: <OpenBookTextOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:school_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isImportFromToddleLibrary &&
          showToddleLibraryOption && {
            key: "IMPORT_FROM_TODDLE_LIBRARY",
            label: "common:toddle_library_lowercase",
            icon: <JournalOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:toddle_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
          },
      ]),
    },
  ];

  const result = _.compact([
    ...(isScheduleView
      ? [
          ...isScheduleViewOptions,
          {
            key: "DIVIDER",
            isDivider: true,
          },
        ]
      : []),
    {
      label: "common:create",
      key: "CREATE",
      isItemGroup: true,
      options: [
        ...(isRoot && _.size(createUnitDropDownOptions)
          ? createUnitOptions
          : []),
        ...getDepthWiseSectionOptions({
          depth,
          isModule,
          isFolder,
          isAncestorUnit,
        }),
        !isAncestorUnit &&
          !isUnit && {
            label: "common:quick_task",
            key: "CREATE_QUICK_TASK",
            icon: <QuickTaskOutlined />,
            disabled: !isTermExistsForCurrentLearningCourse,
            disabledTooltip: t(
              "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
              { label: t("common:quick_task") }
            ),
          },
        hideAssessments &&
          learningCourseSubjectType === SUBJECT_TYPE_EE &&
          canCreateAIChatTask &&
          getIsAITutorInEEEnabled() && {
            ...createAITutorOption,
          },
        ...(hideAssessments
          ? []
          : [
              {
                label: "common:le_label_plural",
                key: "CREATE_LE",
                icon: <LeOutlined />,
                disabled:
                  !isTermExistsForCurrentLearningCourse ||
                  !isUnlockedTermExistsForCurrentLearningCourse,
                disabledTooltip: !isTermExistsForCurrentLearningCourse
                  ? t(
                      "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
                      { label: t("common:le_label_plural") }
                    )
                  : t(
                      "course:item_cannot_be_added_due_to_locked_grading_periods"
                    ),
              },
              ...(canCreateAssessments
                ? [
                    {
                      label: "common:formative_assessments",
                      key: "CREATE_FA",
                      icon: <FaOutlined />,
                      disabled:
                        !isTermExistsForCurrentLearningCourse ||
                        !isUnlockedTermExistsForCurrentLearningCourse,
                      disabledTooltip: !isTermExistsForCurrentLearningCourse
                        ? t(
                            "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
                            { label: t("common:formative_assessments") }
                          )
                        : t(
                            "course:item_cannot_be_added_due_to_locked_grading_periods"
                          ),
                    },
                    {
                      label: "common:summative_assessments",
                      key: "CREATE_SA",
                      icon: <SaOutlined />,
                      disabled:
                        !isTermExistsForCurrentLearningCourse ||
                        !isUnlockedTermExistsForCurrentLearningCourse,
                      disabledTooltip: !isTermExistsForCurrentLearningCourse
                        ? t(
                            "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
                            { label: t("common:summative_assessments") }
                          )
                        : t(
                            "course:item_cannot_be_added_due_to_locked_grading_periods"
                          ),
                    },
                  ]
                : []),
              ...(curriculumType === CURRICULUM_TYPE_UBD
                ? [
                    {
                      label: "common:assessment",
                      key: "CREATE_ASSESSMENT",
                      icon: <AssessmentAddOutlined />,
                      disabled:
                        !isTermExistsForCurrentLearningCourse ||
                        !isUnlockedTermExistsForCurrentLearningCourse,
                      disabledTooltip: !isTermExistsForCurrentLearningCourse
                        ? t(
                            "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
                            {
                              label: t("common:assessment"),
                            }
                          )
                        : t(
                            "course:item_cannot_be_added_due_to_locked_grading_periods"
                          ),
                    },
                  ]
                : []),
              ...(canCreateWorksheets
                ? [
                    {
                      label: "common:worksheet_other",
                      key: "CREATE_WORKSHEET",
                      value: ASSESSMENT_TYPE_WORKSHEET,
                      icon: <WorksheetClipboardOutlined />,
                      disabled:
                        !isTermExistsForCurrentLearningCourse ||
                        !isUnlockedTermExistsForCurrentLearningCourse,
                      disabledTooltip: !isTermExistsForCurrentLearningCourse
                        ? t(
                            "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
                            { label: t("common:worksheet_other") }
                          )
                        : t(
                            "course:item_cannot_be_added_due_to_locked_grading_periods"
                          ),
                    },
                  ]
                : []),
              ...(canCreateAIChatTask
                ? [
                    {
                      ...createAITutorOption,
                    },
                  ]
                : []),
            ]),
        { label: "common:note", key: "ADD_NOTE", icon: <NoteOutlined /> },
        { label: "common:link", key: "ADD_LINK", icon: <LinkOutlined /> },
        {
          label: "common:upload_from",
          key: "upload_menu",
          isSubMenu: true,
          showDivider: false,
          icon: <UploadOutlined />,
          options: [
            {
              key: "add_google_drive",
              label: "common:google_drive",
              icon: <GoogleDriveColored />,
            },
            {
              key: "add_one_drive",
              label: "common:one_drive",
              icon: <OneDriveColored />,
            },
            {
              key: "upload_device",
              label: "common:device",
              icon: <DeviceDesktopOutlined />,
            },
          ],
        },
        {
          key: "MORE",
          label: "common:more",
          icon: <DotsHorizontalOutlined />,
          isSubMenu: true,
          options: [],
        },
      ],
    },
    ...(!isScheduleView ? [importMenu] : []),
  ]);

  return result;
};

export const getTemplateIdFromTaskType = (
  taskTypeId,
  gradeId,
  curriculumId,
  isGradeWiseAssessment = false
) => {
  const data = getAssessmentTemplatesFromCache(curriculumId);

  if (_.isEmpty(data)) {
    return null;
  }

  const taskTypes = _.get(data, "taskTypes", []);

  const taskType = _.find(taskTypes, { id: taskTypeId });

  if (_.isEmpty(taskType)) {
    return null;
  }

  const templates = _.get(taskType, "templates", []);

  // Filter templates by grade if grade-wise assessment is enabled and gradeId is provided
  if (isGradeWiseAssessment && gradeId) {
    const filteredTemplates = _.filter(templates, template => {
      const templateGrades = _.get(template, "grades", []);
      return _.some(templateGrades, grade => grade.id === gradeId);
    });

    if (_.isEmpty(filteredTemplates)) {
      return _.get(_.first(templates), "id", null);
    } else {
      return _.get(_.first(filteredTemplates), "id", null);
    }
  }

  // When not filtering by grade, return the first template
  return _.get(_.first(templates), "id", null);
};

const getAddDropDownOptionsV2 = ({
  t,
  isRoot,
  curriculumType,
  curriculumProgramId,
  depth,
  isModule,
  isFolder,
  isUnit,
  isAncestorUnit,
  hideAssessments = false,
  unitTypeOptions,
  plannerTemplates,
  currentCourseViewType,
  isCourseBasedGradingEnabled,
  isTermExistsForCurrentLearningCourse,
  isUnlockedTermExistsForCurrentLearningCourse = true,
  learningCourseSubjects = [],
  gradeId,
  isClassFlowEnabledInAnyAY = false,
  baseCurriculum,
}) => {
  const isImportFromClassFlowEnabled = getIsImportFromClassFlowInCoursePlanEnabled();
  const anotherCourseKey = isImportFromClassFlowEnabled
    ? "IMPORT_FROM_ANOTHER_COURSE_CLASS_FLOW"
    : "IMPORT_FROM_ANOTHER_COURSE";
  const anotherCourseLabel =
    isImportFromClassFlowEnabled && isClassFlowEnabledInAnyAY
      ? "course:another_course_class_flow"
      : "course:another_course";
  const isUnitOnlyFeed = _.includes(
    [CARD, TIMELINE, TABLE, CARD_VIEW, TIMELINE_VIEW, COURSE_OVERVIEW],
    currentCourseViewType
  );
  const isScheduleView = _.includes([SCHEDULE], currentCourseViewType);

  const isMapleBearLikeOrg = ACLStore.can("FeatureFlag:IsMapleBearLikeOrg");
  const showSchoolLibraryOption = isSchoolLibraryEnabled();
  const showToddleLibraryOption = isToddleLibraryEnabled();

  const SUBJECT_TYPES_TO_EXCLUDE_FROM_LIBRARY = ["EE", "CAS"];
  const shouldHideLibraryOptions =
    _.isEqual(curriculumType, CURRICULUM_TYPE_DP) &&
    _.some(learningCourseSubjects, subject =>
      _.includes(SUBJECT_TYPES_TO_EXCLUDE_FROM_LIBRARY, _.get(subject, "type"))
    );

  const { createUnitDropDownOptions } = getCreateUnitDropdownConfig({
    unitTypeOptions,
    plannerTemplates,
    hideImportOptions: true,
    isCourseBasedGradingEnabled,
    isLearningCoursesEnabled: true,
    curriculumType,
    learningCourseSubjects,
  });

  const isImportFromToddleLibrary = getIsImportFromToddleLibraryEnabled();
  const isImportUnitFromAnotherCourse = getIsImportUnitFromAnotherCourseEnabled();

  const baseCurriculumImportOption = baseCurriculum && {
    key: "import_from_base_library",
    label: baseCurriculum.label,
    isLabelLocalized: true,
    icon: <OpenBookTextOutlined />,
    disabled:
      !isTermExistsForCurrentLearningCourse ||
      !isUnlockedTermExistsForCurrentLearningCourse,
    disabledTooltip: !isTermExistsForCurrentLearningCourse
      ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
          label: t("course:course"),
        })
      : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
  };

  const assessmentTemplatesData = getAssessmentTemplatesFromCache(
    curriculumProgramId
  );
  const taskTypes = _.get(assessmentTemplatesData, "taskTypes", []);
  const sortedTaskTypes = _.sortBy(taskTypes, "displaySequence");
  const isGradeWiseAssessment = ACLStore.can(ENABLE_GRADE_WISE_ASSESSMENT);
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  const assessmentOptions = _.map(sortedTaskTypes, taskType => {
    const type = _.get(taskType, "type", "");
    const label = _.get(taskType, "label", "");
    const color = _.get(taskType, "color", "");
    const taskTypeId = _.get(taskType, "id", "");

    const templateId = getTemplateIdFromTaskType(
      taskTypeId,
      gradeId,
      curriculumProgramId,
      isGradeWiseAssessment
    );

    const avatarName = getTaskTypeAvatarName({
      type,
      label,
      isAssessmentTypeConfigurationEnabled,
    });

    return {
      label: label,
      key: taskTypeId,
      value: taskTypeId,
      taskType: type,
      taskTypeId,
      templateId,
      icon: (
        <Avatar
          shape="square"
          size="large"
          name={avatarName}
          color={color}
          dsVersion="2.0"
        />
      ),
      disabled:
        !isTermExistsForCurrentLearningCourse ||
        !isUnlockedTermExistsForCurrentLearningCourse,
      disabledTooltip: !isTermExistsForCurrentLearningCourse
        ? t(
            "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
            { label }
          )
        : t("course:item_cannot_be_added_due_to_locked_grading_periods"),
    };
  });

  const createUnitOptions = [
    buildCreateUnitOption({
      t,
      isTermExistsForCurrentLearningCourse,
      createUnitDropDownOptions,
    }),
  ];

  if (isUnitOnlyFeed) {
    const importOpts = _.compact([
      isImportUnitFromAnotherCourse && {
        key: "IMPORT_FROM_ANOTHER_COURSE",
        label: "course:another_course",
        icon: <ClassProgressOutlined />,
        disabled:
          !isTermExistsForCurrentLearningCourse ||
          !isUnlockedTermExistsForCurrentLearningCourse,
        disabledTooltip: !isTermExistsForCurrentLearningCourse
          ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
              label: t("course:course"),
            })
          : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
      },
      showSchoolLibraryOption && {
        key: "IMPORT_UNIT_FROM_LIBRARY",
        disabled:
          !isTermExistsForCurrentLearningCourse ||
          !isUnlockedTermExistsForCurrentLearningCourse,
        disabledTooltip: !isTermExistsForCurrentLearningCourse
          ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
              label: t("course:course"),
            })
          : t("course:items_cannot_be_imported_due_to_locked_grading_periods"),
        label: "common:school_library",
        icon: <OpenBookTextOutlined />,
      },
      isImportFromToddleLibrary &&
        showToddleLibraryOption && {
          key: "IMPORT_UNIT_FROM_TODDLE_LIBRARY",
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
          label: "common:toddle_library_lowercase",
          icon: <JournalOutlined />,
        },
      baseCurriculumImportOption,
    ]);

    return _.compact([
      isRoot &&
        _.size(createUnitDropDownOptions) && {
          label: "common:create",
          key: "CREATE",
          isItemGroup: true,
          options: createUnitOptions,
        },
      {
        label: "common:import_from",
        key: "import_menu",
        isItemGroup: true,
        icon: <ImportOutlined />,
        options: importOpts,
      },
    ]);
  }

  let importMenu;
  if (isImportFromToddleLibrary && showToddleLibraryOption) {
    importMenu = {
      label: "common:import_from",
      key: "import_menu",
      isItemGroup: true,
      icon: <ImportOutlined />,
      options: _.compact([
        isRoot && {
          key: anotherCourseKey,
          label: anotherCourseLabel,
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        showSchoolLibraryOption && {
          key: "SCHOOL_LIBRARY",
          label: "common:school_library",
          icon: <OpenBookTextOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:school_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
          isSubMenu: true,
          options: _.compact([
            isRoot &&
              !shouldHideLibraryOptions && {
                key: "IMPORT_UNIT_FROM_LIBRARY",
                label: "common:unit",
                icon: <OpenBookTextOutlined />,
              },
            {
              key: "IMPORT_LE_FROM_LE_LIBRARY",
              label: "common:le_and_assessments",
              icon: <LeLibraryOutlined />,
            },
          ]),
        },
        !isMapleBearLikeOrg &&
          ((isRoot && !shouldHideLibraryOptions) || !hideAssessments) && {
            key: "TODDLE_LIBRARY",
            label: "common:toddle_library_lowercase",
            icon: <JournalOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:toddle_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
            isSubMenu: true,
            options: _.compact([
              isRoot &&
                !shouldHideLibraryOptions && {
                  key: "IMPORT_UNIT_FROM_TODDLE_LIBRARY",
                  label: "common:unit",
                  icon: <OpenBookTextOutlined />,
                },
              !hideAssessments && {
                key: "IMPORT_FROM_TODDLE_LIBRARY",
                label: "common:le_and_assessments",
                icon: <LeLibraryOutlined />,
              },
            ]),
          },
        isRoot && !shouldHideLibraryOptions && baseCurriculumImportOption,
      ]),
    };
  } else {
    importMenu = {
      label: "common:import_from",
      key: "import_menu",
      isSubMenu: true,
      icon: <ImportOutlined />,
      options: _.compact([
        isRoot && {
          key: anotherCourseKey,
          label: anotherCourseLabel,
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isRoot &&
          showSchoolLibraryOption &&
          !shouldHideLibraryOptions && {
            key: "IMPORT_UNIT_FROM_LIBRARY",
            label: "common:school_library",
            icon: <OpenBookTextOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:school_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
          },
        showSchoolLibraryOption && {
          key: "IMPORT_LE_FROM_LE_LIBRARY",
          label: "common:learning_experience_and_assessment_library",
          icon: <LeLibraryOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:learning_experience_and_assessment_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isRoot && !shouldHideLibraryOptions && baseCurriculumImportOption,
      ]),
    };
  }

  const isScheduleViewOptions = [
    {
      label: "common:add_content_from",
      key: "ADD_CONTENT_FROM",
      isSubMenu: true,
      showDivider: false,
      icon: <AddOutlined />,
      options: [
        {
          key: "ADD_FROM_COURSE_FLOW",
          label: "course:course_flow",
          icon: <DashboardOutlined />,
        },
        {
          key: "ADD_FROM_CLASS_ASSIGNMENTS",
          label: "classRoom:class_assignments",
          icon: <AssessmentOutlined />,
        },
      ],
    },
    {
      label: "common:import_from",
      key: "import_menu",
      isSubMenu: true,
      icon: <ImportOutlined />,
      options: _.compact([
        {
          key: "IMPORT_FROM_ANOTHER_COURSE",
          label: "course:another_course",
          icon: <ClassProgressOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("course:course"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        showSchoolLibraryOption && {
          key: "IMPORT_FROM_SCHOOL_LIBRARY",
          label: "common:school_library",
          icon: <OpenBookTextOutlined />,
          disabled:
            !isTermExistsForCurrentLearningCourse ||
            !isUnlockedTermExistsForCurrentLearningCourse,
          disabledTooltip: !isTermExistsForCurrentLearningCourse
            ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                label: t("common:school_library"),
              })
            : t(
                "course:items_cannot_be_imported_due_to_locked_grading_periods"
              ),
        },
        isImportFromToddleLibrary &&
          showToddleLibraryOption && {
            key: "IMPORT_FROM_TODDLE_LIBRARY",
            label: "common:toddle_library_lowercase",
            icon: <JournalOutlined />,
            disabled:
              !isTermExistsForCurrentLearningCourse ||
              !isUnlockedTermExistsForCurrentLearningCourse,
            disabledTooltip: !isTermExistsForCurrentLearningCourse
              ? t("classRoom:import_from_label_no_grading_periods_tooltip", {
                  label: t("common:toddle_library"),
                })
              : t(
                  "course:items_cannot_be_imported_due_to_locked_grading_periods"
                ),
          },
      ]),
    },
  ];

  const result = _.compact([
    ...(isScheduleView
      ? [
          ...isScheduleViewOptions,
          {
            key: "DIVIDER",
            isDivider: true,
          },
        ]
      : []),
    {
      label: "common:create",
      key: "CREATE",
      isItemGroup: true,
      options: [
        ...(isRoot && _.size(createUnitDropDownOptions)
          ? createUnitOptions
          : []),
        ...getDepthWiseSectionOptions({
          depth,
          isModule,
          isFolder,
          isAncestorUnit,
        }),
        ...(hideAssessments ? [] : assessmentOptions),
        { label: "common:note", key: "ADD_NOTE", icon: <NoteOutlined /> },
        { label: "common:link", key: "ADD_LINK", icon: <LinkOutlined /> },
        {
          label: "common:upload_from",
          key: "upload_menu",
          isSubMenu: true,
          showDivider: false,
          icon: <UploadOutlined />,
          options: [
            {
              key: "add_google_drive",
              label: "common:google_drive",
              icon: <GoogleDriveColored />,
            },
            {
              key: "add_one_drive",
              label: "common:one_drive",
              icon: <OneDriveColored />,
            },
            {
              key: "upload_device",
              label: "common:device",
              icon: <DeviceDesktopOutlined />,
            },
          ],
        },
      ],
    },
    ...(!isScheduleView ? [importMenu] : []),
  ]);

  return result;
};

export const getAddDropDownOptionsMemoized = getMemoizedLangFunction(
  getAddDropDownOptions
);

export const getAddDropDownOptionsMemoizedV2 = getMemoizedFunction(
  getAddDropDownOptionsV2
);

const getDisplaySettings = ({
  t,
  isBlueprintCourse,
  isUserTeacher,
  isTeacherCourseAssociationEnabled,
  isCourseAssociatedWithBlueprint,
}) => {
  const showBlueprintLockIcon =
    !isBlueprintCourse &&
    isUserTeacher &&
    isTeacherCourseAssociationEnabled &&
    isCourseAssociatedWithBlueprint;

  return [
    {
      key: "show_outline",
      label: t("classMaterials:show_outline"),
      type: "checkbox",
      hasDivider: true,
    },
    {
      key: "collapse_sections",
      isItemGroup: true,
      options: [
        {
          key: "collapse_all_sections",
          label: t("classMaterials:collapse_all_sections"),
          type: "radio",
        },
        {
          key: "expand_all_sections",
          label: t("classMaterials:expand_all_sections"),
          type: "radio",
        },
      ],
    },
    ...(isUserTeacher
      ? [
          {
            key: "default_item_placement",
            label: t("classMaterials:default_item_placement"),
            isItemGroup: true,
            options: [
              {
                key: "add_to_top",
                label: t("classMaterials:add_to_top"),
                type: "radio",
              },
              {
                key: "add_to_bottom",
                label: t("classMaterials:add_to_bottom"),
                type: "radio",
              },
            ],
          },
        ]
      : []),
    {
      key: "task_resource_icon",
      label: t("classMaterials:task_resource_icon"),
      isItemGroup: true,
      options: [
        {
          key: "thumbnail_image",
          label: t("classMaterials:thumbnail_image"),
          type: "radio",
        },
        {
          key: "task_resource_type",
          label: t("classMaterials:task_resource_type"),
          type: "radio",
        },
      ],
    },
    {
      key: "task_details",
      label: t("classMaterials:task_details"),
      isItemGroup: true,
      options: [
        ...(showBlueprintLockIcon
          ? [
              {
                key: "show_blueprint_lock",
                label: t("course:show_blueprint_lock_indicator"),
                type: "checkbox",
              },
            ]
          : []),
        {
          key: "grading_period",
          label: t("common:grading_period"),
          type: "checkbox",
        },
        {
          key: "assessment_category",
          label: t("classMaterials:assessment_category"),
          type: "checkbox",
        },
      ],
    },
  ];
};

export const getDisplaySettingsMemoized = getMemoizedLangFunction(
  getDisplaySettings
);

export const LOCKING_SCOPE = {
  SELF: "SELF",
  SELF_AND_CHILDREN: "SELF_AND_CHILDREN",
  CHILDREN: "CHILDREN",
};

export const LOCKING_ACTIONS = {
  LOCK_UNIT_AND_ITEMS: "LOCK_UNIT_AND_ITEMS",
  LOCK_UNIT_ONLY: "LOCK_UNIT_ONLY",
  LOCK_ITEMS_ONLY: "LOCK_ITEMS_ONLY",
  UNLOCK_UNIT_AND_ITEMS: "UNLOCK_UNIT_AND_ITEMS",
  UNLOCK_UNIT_ONLY: "UNLOCK_UNIT_ONLY",
  UNLOCK_ITEMS_ONLY: "UNLOCK_ITEMS_ONLY",
  LOCK_SECTION_ONLY: "LOCK_SECTION_ONLY",
  UNLOCK_SECTION_ONLY: "UNLOCK_SECTION_ONLY",
  LOCK_SECTION_AND_ITEMS: "LOCK_SECTION_AND_ITEMS",
  UNLOCK_SECTION_AND_ITEMS: "UNLOCK_SECTION_AND_ITEMS",
  LOCK_ITEM: "LOCK_ITEM",
  UNLOCK_ITEM: "UNLOCK_ITEM",
  UNIT_ITEM_LOCK: "UNIT_ITEM_LOCK",
};

const DIVIDER = "divider";

const getCardActionTooltipWithPrecedence = ({
  t,
  hasClasses,
  hasStudents,
  isGradingPeriodUnlocked,
  isClassFilterApplied,
  classText,
  entityText,
  tooltipType = "sharing", // 'sharing', 'assigning', 'file-sharing'
  returnAsObject = false, // for spread syntax in sharing buttons
}) => {
  const getTooltipText = () => {
    if (!hasClasses) {
      return t("course:no_classes_added");
    }
    if (!hasStudents) {
      return t("common:no_students_enrolled");
    }

    switch (tooltipType) {
      case "assigning":
        if (!isGradingPeriodUnlocked) {
          return t("course:you_cannot_with_label_since_locked", {
            actionLabel: t("common:assign"),
          });
        }
        return t("course:assign_to_all_with_default_settings_to_class", {
          entityText,
          classText,
        });

      case "file-sharing":
        return isClassFilterApplied
          ? t("course:share_with_all_students_of_class", { classText })
          : t("course:share_with_all_classes");

      case "sharing":
      default:
        return "";
    }
  };

  const tooltipText = getTooltipText();

  if (returnAsObject) {
    return tooltipText ? { tooltip: tooltipText } : {};
  }

  return tooltipText;
};

const getTeacherCourseCardActions = ({
  t,
  type,
  isShared,
  totalChildren,
  studentList,
  associatedClasses,
  isGradingPeriodUnlocked,
  isClassFilterApplied,
  selectedClassTitle,
}) => {
  const hasClasses = _.size(associatedClasses) > 0;
  const hasStudents = _.size(studentList) > 0;
  const isProSchool = getIsProSchool();

  let classText = _.toLower(t("common:all_classes_plural"));
  let entityText = t("common:class_lowercase_other");

  if (isClassFilterApplied) {
    classText = selectedClassTitle;
    entityText = t("common:student_plural_lowercase");
  }

  switch (type) {
    case "UNIT_PLAN": {
      if (!isShared) {
        return [
          ...(totalChildren > 0
            ? [
                {
                  key: "SHARE_BUTTON",
                  type: "SplitButton",
                  action: "UNIT_SHARE_WITH_ALL_CONTENT",
                  isDisabled: !hasClasses || !hasStudents,
                  label: t("course:share_unit_with_all_items"),
                  ...getCardActionTooltipWithPrecedence({
                    t,
                    hasClasses,
                    hasStudents,
                    tooltipType: "sharing",
                    returnAsObject: true,
                  }),
                  icon: <MarkAsReadOutlined />,
                  options: [
                    {
                      key: "UNIT_SHARE_WITH_ALL_CONTENT",
                      label: t("course:share_unit_with_all_items"),
                      subText: t(
                        "course:share_unit_with_all_items_to_class_subtext",
                        { classText }
                      ),
                      icon: <MarkAsReadOutlined />,
                    },

                    {
                      key: "UNIT_SHARE",
                      label: t("course:share_unit_only"),
                      subText: t("course:share_unit_only_to_class_subtext", {
                        classText,
                      }),
                      icon: <TickCircleOutlined />,
                    },
                  ],
                },
              ]
            : [
                {
                  key: "UNIT_SHARE_WITH_ALL_CONTENT",
                  type: "Button",
                  action: "UNIT_SHARE_WITH_ALL_CONTENT",
                  label: t("course:share_label", { label: t("common:unit") }),
                  isDisabled: !hasClasses || !hasStudents,
                  icon: <MarkAsReadOutlined />,
                  ...getCardActionTooltipWithPrecedence({
                    t,
                    hasClasses,
                    hasStudents,
                    tooltipType: "sharing",
                    returnAsObject: true,
                  }),
                },
              ]),
        ];
      }
      break;
    }

    case "FOLDER": {
      if (!isShared) {
        return [
          ...(totalChildren > 0
            ? [
                {
                  key: "SHARE_BUTTON",
                  type: "SplitButton",
                  action: "SECTION_SHARE_WITH_ALL_CONTENT",
                  isDisabled: !hasClasses || !hasStudents,
                  label: t("course:share_section_with_all_items"),
                  ...getCardActionTooltipWithPrecedence({
                    t,
                    hasClasses,
                    hasStudents,
                    tooltipType: "sharing",
                    returnAsObject: true,
                  }),
                  icon: <MarkAsReadOutlined />,
                  options: [
                    {
                      key: "SECTION_SHARE_WITH_ALL_CONTENT",
                      label: t("course:share_section_with_all_items"),
                      subText: t(
                        "course:share_section_with_all_items_to_class_subtext",
                        { classText }
                      ),
                      icon: <MarkAsReadOutlined />,
                    },
                    {
                      key: "SECTION_SHARE",
                      label: t("course:share_section_only"),
                      subText: t(
                        "course:share_section_without_content_to_class_subtext",
                        { classText }
                      ),
                      icon: <TickCircleOutlined />,
                    },
                  ],
                },
              ]
            : [
                {
                  key: "SECTION_SHARE_WITH_ALL_CONTENT",
                  type: "Button",
                  action: "SECTION_SHARE_WITH_ALL_CONTENT",
                  label: t("course:share_label", {
                    label: t("common:folder"),
                  }),
                  isDisabled: !hasClasses || !hasStudents,
                  icon: <MarkAsReadOutlined />,
                  ...getCardActionTooltipWithPrecedence({
                    t,
                    hasClasses,
                    hasStudents,
                    tooltipType: "sharing",
                    returnAsObject: true,
                  }),
                },
              ]),
        ];
      }
      break;
    }

    case "ASSESSMENT": {
      if (!isShared && !isProSchool) {
        return [
          {
            key: "QUICK_ASSIGN",
            type: "Button",
            action: "ASSESSMENT_QUICK_ASSIGN",
            label: t("classMaterials:quick_assign"),
            isDisabled: !hasClasses || !isGradingPeriodUnlocked || !hasStudents,
            icon: <TickCircleOpenOutlined />,
            tooltip: getCardActionTooltipWithPrecedence({
              t,
              hasClasses,
              hasStudents,
              isGradingPeriodUnlocked,
              classText,
              entityText,
              tooltipType: "assigning",
            }),
            tooltipPlacement: "top",
          },
        ];
      }
      break;
    }

    case "FILE": {
      if (!isShared) {
        return [
          {
            key: "QUICK_SHARE",
            type: "Button",
            action: "FILE_QUICK_SHARE",
            label: t("classMaterials:quick_share"),
            isDisabled: !hasClasses || !hasStudents,
            icon: <TickCircleOpenOutlined />,
            tooltip: getCardActionTooltipWithPrecedence({
              t,
              hasClasses,
              hasStudents,
              isGradingPeriodUnlocked: true, // file sharing doesn't depend on grading period
              isClassFilterApplied,
              classText,
              entityText: "",
              tooltipType: "file-sharing",
            }),
            tooltipPlacement: "top",
          },
        ];
      }
      break;
    }
  }
};

export const getUnitLockingOptions = ({
  isLocked,
  hasConflict,
  hasUnlockedChildren,
  t,
  showItemLevelLocking = false,
}) => {
  let options = [];
  const showDisabled = hasConflict && !isLocked;

  if (!isLocked && hasUnlockedChildren) {
    // When unit is not locked and has unlocked children (any child is unlocked)
    options = [
      {
        key: LOCKING_ACTIONS.LOCK_UNIT_AND_ITEMS,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_unit_and_all_items"),
        subText: t("course:lock_unit_and_all_items_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_UNIT_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_unit_only"),
        subText: t("course:lock_unit_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_ITEMS_ONLY,
        label: t("course:lock_unit_flow_only"),
        subText: t("course:lock_unit_flow_only_subtext"),
      },
      ...(showItemLevelLocking
        ? [
            {
              key: DIVIDER,
              isDivider: true,
            },
            {
              key: LOCKING_ACTIONS.UNIT_ITEM_LOCK,
              label: t("course:manage_item_level_locking"),
            },
          ]
        : []),
    ];
  } else if (!isLocked && !hasUnlockedChildren) {
    // When unit is not locked but all children are locked — offer to lock the unit or unlock flow
    options = [
      {
        key: LOCKING_ACTIONS.LOCK_UNIT_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_unit_only"),
        subText: t("course:lock_unit_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_ITEMS_ONLY,
        label: t("course:unlock_unit_flow_only"),
        subText: t("course:unlock_unit_flow_only_subtext"),
      },
      ...(showItemLevelLocking
        ? [
            {
              key: DIVIDER,
              isDivider: true,
            },
            {
              key: LOCKING_ACTIONS.UNIT_ITEM_LOCK,
              label: t("course:manage_item_level_locking"),
            },
          ]
        : []),
    ];
  } else if (isLocked && hasUnlockedChildren) {
    // When unit is locked but some children are unlocked — show lock option for children
    options = [
      {
        key: LOCKING_ACTIONS.UNLOCK_UNIT_ONLY,
        label: t("course:unlock_unit"),
        subText: t("course:unlock_unit_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_ITEMS_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_unit_flow_only"),
        subText: t("course:lock_unit_flow_only_subtext"),
      },
      ...(showItemLevelLocking
        ? [
            {
              key: DIVIDER,
              isDivider: true,
            },
            {
              key: LOCKING_ACTIONS.UNIT_ITEM_LOCK,
              label: t("course:manage_item_level_locking"),
            },
          ]
        : []),
    ];
  } else {
    // When unit is locked and all children are locked — show full unlock options
    options = [
      {
        key: LOCKING_ACTIONS.UNLOCK_UNIT_AND_ITEMS,
        label: t("course:unlock_unit_and_all_items"),
        subText: t("course:unlock_unit_and_all_items_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_UNIT_ONLY,
        label: t("course:unlock_unit_only"),
        subText: t("course:unlock_unit_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_ITEMS_ONLY,
        label: t("course:unlock_unit_flow_only"),
        subText: t("course:unlock_unit_flow_only_subtext"),
      },
      ...(showItemLevelLocking
        ? [
            {
              key: DIVIDER,
              isDivider: true,
            },
            {
              key: LOCKING_ACTIONS.UNIT_ITEM_LOCK,
              label: t("course:manage_item_level_locking"),
            },
          ]
        : []),
    ];
  }

  return options;
};

export const getFolderLockingOptions = ({
  isLocked,
  hasUnlockedChildren,
  showDisabled,
  t,
}) => {
  let options = [];

  if (!isLocked && hasUnlockedChildren) {
    // When section is not locked and has unlocked children (any child is unlocked)
    options = [
      {
        key: LOCKING_ACTIONS.LOCK_SECTION_AND_ITEMS,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_section_and_all_items"),
        subText: t("course:lock_section_and_all_items_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_SECTION_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_section_only"),
        subText: t("course:lock_section_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_ITEMS_ONLY,
        label: t("course:lock_section_items_only"),
        subText: t("course:lock_section_items_only_subtext"),
      },
    ];
  } else if (!isLocked && !hasUnlockedChildren) {
    // When section is not locked but all children are locked — offer to lock section or unlock children
    options = [
      {
        key: LOCKING_ACTIONS.LOCK_SECTION_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_section_only"),
        subText: t("course:lock_section_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_ITEMS_ONLY,
        label: t("course:unlock_items_only"),
        subText: t("course:unlock_section_items_subtext"),
      },
    ];
  } else if (isLocked && hasUnlockedChildren) {
    // When section is locked but some children are unlocked — show lock option for children
    options = [
      {
        key: LOCKING_ACTIONS.UNLOCK_SECTION_ONLY,
        label: t("course:unlock_section"),
        subText: t("course:unlock_section_subtext"),
      },
      {
        key: LOCKING_ACTIONS.LOCK_ITEMS_ONLY,
        disabled: showDisabled,
        disabledTooltip: t("course:cannot_lock_in_conflict"),
        label: t("course:lock_section_items_only"),
        subText: t("course:lock_section_items_only_subtext"),
      },
    ];
  } else {
    // When section is locked and all children are locked — show full unlock options
    options = [
      {
        key: LOCKING_ACTIONS.UNLOCK_SECTION_AND_ITEMS,
        label: t("course:unlock_section_and_all_items"),
        subText: t("course:unlock_section_and_all_items_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_SECTION_ONLY,
        label: t("course:unlock_section_only"),
        subText: t("course:unlock_section_only_subtext"),
      },
      {
        key: LOCKING_ACTIONS.UNLOCK_ITEMS_ONLY,
        label: t("course:unlock_items_only"),
        subText: t("course:unlock_section_items_subtext"),
      },
    ];
  }

  return options;
};

export const getMixedStatusToolTipText = ({ syncStatus = {}, t }) => {
  const syncCourses = _.get(syncStatus, "courseSyncStatus", []);

  const sections = [
    {
      title: t("common:synced_in"),
      courses: _.filter(syncCourses, { status: SYNC_STATUS.IN_SYNC }),
    },
    {
      title: t("common:pending_in"),
      courses: _.filter(syncCourses, { status: SYNC_STATUS.PENDING_SYNC }),
    },
    {
      title: t("common:cannot_sync_in"),
      courses: _.filter(syncCourses, { status: SYNC_STATUS.CANNOT_SYNC }),
    },
  ];

  const Section = ({ title, courses, idx }) => {
    if (_.isEmpty(courses)) return null;

    return (
      <div style={{ marginBottom: idx !== sections.length - 1 ? 12 : 0 }}>
        <div>{title}</div>
        <div style={{ margin: 0, paddingLeft: 18 }}>
          {_.map(courses, course => (
            <li key={_.get(course, "course.id")}>
              {_.get(course, "course.title", "")}
            </li>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      {_.map(sections, ({ title, courses }, idx) => (
        <Section key={title} title={title} courses={courses} idx={idx} />
      ))}
    </>
  );
};

export const getSyncStatusCompData = ({
  syncStatus = {},
  t,
  size = "xxx-small",
}) => {
  const status = _.get(syncStatus, "status", null);

  switch (status) {
    case SYNC_STATUS.IN_SYNC:
      return {
        icon: <SyncCompleteOutlined variant="success" size={size} />,
        tooltip: t("common:all_updates_synced_with_teacher_courses"),
        tooltipPlacement: "top",
        defaultIcon: <SyncCompleteOutlined />,
      };
    case SYNC_STATUS.PENDING_SYNC:
      return {
        icon: <DashedCircleOutlined variant="subtle" size={size} />,
        tooltip: t("common:pending_sync_with_teacher_courses"),
        tooltipPlacement: "top",
        defaultIcon: <DashedCircleOutlined />,
      };
    case SYNC_STATUS.MIXED:
      return {
        icon: <DashedCircleMinusOutlined variant="warning" size={size} />,
        tooltip: getMixedStatusToolTipText({ syncStatus, t }),
        tooltipPlacement: "top",
        defaultIcon: <DashedCircleMinusOutlined />,
      };
    case SYNC_STATUS.CANNOT_SYNC:
      return {
        icon: <SyncPendingOutlined variant="critical" size={size} />,
        tooltip: t("common:conflict_with_all_teacher_courses"),
        tooltipPlacement: "top",
        defaultIcon: <SyncPendingOutlined />,
      };
    default:
      return {};
  }
};

const getBlueprintCourseCardActions = ({
  t,
  type,
  isLocked,
  hasConflict,
  hasChildren,
  hasLockedChildren,
  hasUnlockedChildren,
  assessmentLabel,
  attachmentType,
  isViewOnlyMode,
  syncStatus = {},
  showItemLevelLocking,
}) => {
  const isConflictBlockingLock =
    !getIsBlueprintSyncHistoryV2Enabled() && hasConflict;
  const showDisabled = isConflictBlockingLock && !isLocked && !isViewOnlyMode;
  let syncStatusActions = [];

  const { icon, tooltip, defaultIcon } =
    getSyncStatusCompData({ syncStatus, t, size: "xx-small" }) || {};

  syncStatusActions = !_.isEmpty(icon)
    ? [
        {
          key: "SYNCED_WITH_TEACHER_COURSE",
          type: "Icon",
          defaultIcon: defaultIcon,
          tooltip: tooltip,
          tooltipPlacement: "top",
          icon: icon,
        },
      ]
    : [];

  const isSyncAndLockAllowed = getIsSyncAndLockAllowed();

  const isRestricted = isViewOnlyMode || !isSyncAndLockAllowed;

  switch (type) {
    case "UNIT_PLAN": {
      let tooltipLocale = isLocked
        ? "course:unlock_item_with_label"
        : "course:lock_item_with_label";

      if (isRestricted) {
        tooltipLocale = isLocked
          ? "course:unlock_item_with_label_read_only"
          : "course:lock_item_with_label_read_only";
      }

      const tooltipLabel = t(tooltipLocale, {
        label: t("common:unit_plan"),
      });

      const buttonType = isRestricted
        ? "Icon"
        : hasChildren
        ? "IconDisclosure"
        : "IconButton";

      return [
        ...syncStatusActions,
        {
          key: isLocked
            ? LOCKING_ACTIONS.UNLOCK_UNIT_ONLY
            : LOCKING_ACTIONS.LOCK_UNIT_ONLY,
          type: buttonType,
          action: isLocked
            ? LOCKING_ACTIONS.UNLOCK_UNIT_ONLY
            : LOCKING_ACTIONS.LOCK_UNIT_ONLY,
          defaultIcon: isLocked ? <LockFilled /> : <LockOpenOutlined />,
          iconClasses: hasChildren ? null : classes.lockIconMargin,
          disabled: !hasChildren && showDisabled,
          tooltip:
            !hasChildren && showDisabled
              ? t("course:cannot_lock_in_conflict")
              : tooltipLabel,
          tooltipPlacement: "top",
          icon: isLocked ? <LockFilled /> : <LockOpenOutlined />,
          options: hasChildren
            ? getUnitLockingOptions({
                isLocked,
                hasConflict: getIsBlueprintSyncHistoryV2Enabled()
                  ? false
                  : hasConflict,
                hasUnlockedChildren,
                showItemLevelLocking,
                t,
              })
            : null,
        },
        ...(isRestricted
          ? []
          : [
              {
                type: "VerticalSeparator",
              },
            ]),
      ];
    }

    case "FOLDER": {
      const options = hasChildren
        ? getFolderLockingOptions({
            isLocked,
            hasUnlockedChildren,
            showDisabled,
            t,
          })
        : null;

      let tooltipLocale = isLocked
        ? "course:unlock_item_with_label"
        : "course:lock_item_with_label";

      if (isRestricted) {
        tooltipLocale = isLocked
          ? "course:unlock_item_with_label_read_only"
          : "course:lock_item_with_label_read_only";
      }

      const tooltipLabel = t(tooltipLocale, {
        label: t("common:folder"),
      });

      const buttonType = isRestricted
        ? "Icon"
        : hasChildren
        ? "IconDisclosure"
        : "IconButton";

      return [
        ...syncStatusActions,
        {
          key: isLocked
            ? LOCKING_ACTIONS.UNLOCK_SECTION_ONLY
            : LOCKING_ACTIONS.LOCK_SECTION_ONLY,
          type: buttonType,
          action: isLocked
            ? LOCKING_ACTIONS.UNLOCK_SECTION_ONLY
            : LOCKING_ACTIONS.LOCK_SECTION_ONLY,
          defaultIcon: isLocked ? <LockFilled /> : <LockOpenOutlined />,
          iconClasses: hasChildren ? null : classes.lockIconMargin,
          disabled: !hasChildren && showDisabled,
          tooltip:
            !hasChildren && showDisabled
              ? t("course:cannot_lock_in_conflict")
              : tooltipLabel,
          tooltipPlacement: "top",
          icon: isLocked ? <LockFilled /> : <LockOpenOutlined />,
          options,
        },
        ...(isRestricted
          ? []
          : [
              {
                type: "VerticalSeparator",
              },
            ]),
      ];
    }

    case "ASSESSMENT": {
      const buttonType = isRestricted ? "Icon" : "IconButton";

      if (!isLocked) {
        const tooltipLocale = isRestricted
          ? "course:lock_item_with_label_read_only"
          : "course:lock_item_with_label";
        const tooltipLabel = t(tooltipLocale, {
          label: assessmentLabel,
        });

        return [
          ...syncStatusActions,
          {
            key: LOCKING_ACTIONS.LOCK_ITEM,
            type: buttonType,
            iconClasses: isRestricted ? null : classes.lockIconMargin,
            action: LOCKING_ACTIONS.LOCK_ITEM,
            disabled: showDisabled,
            tooltip: showDisabled
              ? t("course:cannot_lock_in_conflict")
              : tooltipLabel,
            tooltipPlacement: "top",
            icon: <LockOpenOutlined />,
          },
          ...(isRestricted
            ? []
            : [
                {
                  type: "VerticalSeparator",
                },
              ]),
        ];
      } else {
        const tooltipLocale = isRestricted
          ? "course:unlock_item_with_label_read_only"
          : "course:unlock_item_with_label";
        const tooltipLabel = t(tooltipLocale, {
          label: assessmentLabel,
        });

        return [
          ...syncStatusActions,
          {
            key: LOCKING_ACTIONS.UNLOCK_ITEM,
            type: buttonType,
            iconClasses: isRestricted ? null : classes.lockIconMargin,
            action: LOCKING_ACTIONS.UNLOCK_ITEM,
            tooltip: tooltipLabel,
            tooltipPlacement: "top",
            icon: <LockFilled />,
          },
          ...(isRestricted
            ? []
            : [
                {
                  type: "VerticalSeparator",
                },
              ]),
        ];
      }
    }

    case "FILE": {
      let attachmentLabel = t("common:resource_label");
      if (attachmentType == "NOTE") {
        attachmentLabel = t("common:note");
      } else if (attachmentType == "LINK") {
        attachmentLabel = t("common:link");
      }

      const buttonType = isRestricted ? "Icon" : "IconButton";

      if (!isLocked) {
        const tooltipLocale = isRestricted
          ? "course:lock_item_with_label_read_only"
          : "course:lock_item_with_label";
        const tooltipLabel = t(tooltipLocale, {
          label: attachmentLabel,
        });

        return [
          ...syncStatusActions,
          {
            key: LOCKING_ACTIONS.LOCK_ITEM,
            type: buttonType,
            iconClasses: isRestricted ? null : classes.lockIconMargin,
            action: LOCKING_ACTIONS.LOCK_ITEM,
            disabled: showDisabled,
            tooltip: showDisabled
              ? t("course:cannot_lock_in_conflict")
              : tooltipLabel,
            tooltipPlacement: "top",
            icon: <LockOpenOutlined />,
          },
          ...(isRestricted
            ? []
            : [
                {
                  type: "VerticalSeparator",
                },
              ]),
        ];
      } else {
        const tooltipLocale = isRestricted
          ? "course:unlock_item_with_label_read_only"
          : "course:unlock_item_with_label";
        const tooltipLabel = t(tooltipLocale, {
          label: attachmentLabel,
        });

        return [
          ...syncStatusActions,
          {
            key: LOCKING_ACTIONS.UNLOCK_ITEM,
            type: buttonType,
            iconClasses: isRestricted ? null : classes.lockIconMargin,
            action: LOCKING_ACTIONS.UNLOCK_ITEM,
            tooltip: tooltipLabel,
            tooltipPlacement: "top",
            icon: <LockFilled />,
          },
          ...(isRestricted
            ? []
            : [
                {
                  type: "VerticalSeparator",
                },
              ]),
        ];
      }
    }
  }

  return [];
};

const getCardActions = ({
  t,
  type,
  isShared,
  associatedClasses,
  isGradingPeriodUnlocked,
  totalChildren = 0,
  isBlueprintCourse = false,
  isTeacherCourseAssociationEnabled = false,
  isLocked = false,
  hasConflict = false,
  hasChildren = false,
  hasLockedChildren = false,
  hasUnlockedChildren = false,
  isClassFilterApplied = false,
  selectedClassTitle = "",
  assessmentLabel,
  attachmentType,
  isViewOnlyMode = false,
  studentList,
  syncStatus = {},
  showItemLevelLocking,
  isPreviousAcademicYearSelected = false,
}) => {
  if (isPreviousAcademicYearSelected) {
    return [];
  }

  if (isBlueprintCourse) {
    if (!isTeacherCourseAssociationEnabled) {
      // If teacher course association is not enabled, return empty actions
      return [];
    }

    return getBlueprintCourseCardActions({
      t,
      type,
      isLocked,
      hasConflict,
      assessmentLabel,
      attachmentType,
      hasChildren,
      hasLockedChildren,
      hasUnlockedChildren,
      isViewOnlyMode,
      syncStatus,
      showItemLevelLocking,
    });
  } else {
    return getTeacherCourseCardActions({
      t,
      type,
      isShared,
      totalChildren,
      associatedClasses,
      isGradingPeriodUnlocked,
      isClassFilterApplied,
      studentList,
      selectedClassTitle,
    });
  }
};

export const getCardActionsMemoized = getMemoizedLangFunction(
  getCardActions,
  ({ associatedClasses, ...restParams }) =>
    JSON.stringify({
      ...restParams,
      associatedClasses: _.map(associatedClasses, "id"),
    })
);

const getMoveToSectionOption = ({
  t,
  itemType,
  itemDepth,
  maxChildDepth = 0,
  sectionsCount,
  hasEditAccess = true,
  isUniversalParentEnabled = false,
}) => {
  const isItemUnit = isUnitPlan({ resourceType: itemType });
  const isItemFolder = isFolder({ resourceType: itemType });
  if (isItemUnit) return [];

  if (isUniversalParentEnabled) return [];

  // no need to show move to section option if there are
  // no sections in the feed
  if (sectionsCount === 0) return [];

  if (isItemFolder && itemDepth > MAX_FOLDER_DEPTH_FOR_COURSE_FLOW) return [];

  if (!hasEditAccess) return [];

  let itemStructureDepth = 1;

  if (maxChildDepth > 0) {
    itemStructureDepth += maxChildDepth;
    itemStructureDepth -= itemDepth;
  }

  if (isItemFolder) {
    itemStructureDepth += 1;
  }

  const moveToSectionLabel =
    itemDepth === 1
      ? t("common:move_to_section")
      : t("common:move_to_another_section");

  return [
    {
      key: "MOVE_TO_SECTION",
      label: moveToSectionLabel,
      icon: <SwitchArrowsOutlined />,
      disabled:
        !hasEditAccess || itemStructureDepth > MAX_FOLDER_DEPTH_FOR_COURSE_FLOW,
      disabledTooltip: !hasEditAccess
        ? t("course:no_creation_permission_tooltip")
        : t("common:hierarchy_level_restriction_for_section_with_level", {
            level: MAX_DEPTH_FOR_COURSE_FLOW,
          }),
    },
  ];
};

const getImportFromAnotherCourseModalSteps = ({ t, isFlowView }) => {
  return [
    {
      value: "SELECT_COURSE",
      label: t("toddleLibrary:select_course"),
      config: {
        heading: t("toddleLibrary:select_course"),
        footerConfig: {
          fullWidth: true,
          actionButtons: [
            {
              label: "common:cancel",
              value: "cancel",
            },
            {
              label: "common:next",
              value: "next",
            },
          ],
        },
      },
    },
    {
      value: isFlowView ? "SELECT_ITEMS" : "SELECT_UNITS",
      label: isFlowView
        ? t("common:select_items")
        : t("course:select_units_to_import"),
      config: {
        heading: isFlowView
          ? t("common:select_items")
          : t("common:select_units"),
        isMultiSelect: true,
        footerConfig: {
          fullWidth: true,
          actionButtons: [
            {
              label: "common:previous",
              value: "cancel",
            },
            {
              label: "common:import",
              value: "import",
            },
          ],
        },
      },
    },
  ];
};

export const getImportFromAnotherCourseModalStepsMemoized = getMemoizedLangFunction(
  getImportFromAnotherCourseModalSteps
);

// used to restict drag on unit related items
export const customRestriction = ({
  t,
  activeItem,
  overItem,
  depth,
  parentConfig,
  overItemAncestorId,
  isOverItemAncestorUnit,
  resourceRelationConfig,
}) => {
  const isRootLevel = depth == 1;
  const isActiveItemUnit = isUnitPlan(activeItem);
  const isOverItemUnit = isUnitPlan(overItem);

  if (!isRootLevel && isActiveItemUnit) {
    if (isOverItemUnit) {
      return {
        isDisabled: true,
        warningText: t("course:cannot_move_unit_to_unit"),
      };
    } else {
      return {
        isDisabled: true,
        warningText: t("course:cannot_move_unit_to_section"),
      };
    }
  }

  const activeItemType = _.get(activeItem, "item.type", null);
  const isActiveItemQuickTask = activeItemType === "QUICK_TASK";

  // If active item is a quick task, we cannot move it to a unit
  if (
    !isRootLevel &&
    isActiveItemQuickTask &&
    (isOverItemUnit || isOverItemAncestorUnit)
  ) {
    return {
      isDisabled: true,
      warningText: t("course:cannot_move_quick_task_to_unit"),
    };
  }

  // now only check if over item ancestor is a type of unit plan
  // to furthur check if we are navigating to a different unit
  if (!isRootLevel && isOverItemAncestorUnit) {
    const activeItemAncestorId = _.first(parentConfig[activeItem.id]);

    // if active item and over item are not sibling and also their ancestors are not same
    if (activeItemAncestorId != overItemAncestorId) {
      // Check if active item is a folder and we are trying to move it to a unit
      // If that is the case, we need to restrict the move if that folder contains a QUICK_TASK
      const isActiveItemFolder = isFolder(activeItem);
      let hasQuickTask = false;
      if (isActiveItemFolder) {
        const children = _.get(
          resourceRelationConfig,
          `childrenConfig.${activeItem.id}`,
          []
        );

        hasQuickTask = _.some(children, childId => {
          const childItemType = _.get(
            resourceRelationConfig,
            `resourcesConfig.${childId}.item.type`,
            null
          );
          return childItemType === "QUICK_TASK";
        });
      }

      if (hasQuickTask) {
        return {
          isDisabled: true,
          warningText: t("course:cannot_move_quick_task_section_to_unit"),
        };
      }
    }
  }

  return {};
};
export const isUnitFlowPrintEnabled = () => {
  return ACLStore.can("FeatureFlag:UnitFlowPrint");
};

export const getDisabledTooltipWithPrecedence = ({
  t,
  hasEditAccess,
  hasClasses,
  hasStudents,
  isGradingPeriodUnlocked,
  isTermExistsForCurrentLearningCourse,
  assessmentLabel,
  actionLabel,
  entityType = "sharing", // 'sharing' or 'assigning'
}) => {
  if (entityType === "assigning") {
    if (!isGradingPeriodUnlocked) {
      return t("course:you_cannot_with_label_since_locked", {
        actionLabel,
      });
    }
    if (!isTermExistsForCurrentLearningCourse) {
      return t(
        "classRoom:assign_to_students_no_grading_periods_tooltip_with_label_plural",
        {
          label: assessmentLabel,
        }
      );
    }
  }
  if (!hasClasses) {
    return t("course:no_classes_added");
  }
  if (!hasStudents) {
    return t("common:no_students_enrolled");
  }
  if (!hasEditAccess) {
    return t("course:no_creation_permission_tooltip");
  }
  return "";
};

const getDisabledTooltipForUpdations = ({
  t,
  hasEditAccess,
  isUpdateActionsLocked,
  isGradingPeriodUnlocked,
  entityLabel,
  actionLabel,
  defaultTooltip = "",
  isDelete = false,
}) => {
  if (isUpdateActionsLocked) {
    const actionLocale = isDelete
      ? "course:locked_item_delete_restriction_tooltip"
      : "course:locked_item_edit_restriction_tooltip";
    return t(actionLocale, {
      entity: entityLabel,
    });
  }

  if (!isGradingPeriodUnlocked) {
    return t("course:you_cannot_with_label_since_locked", {
      actionLabel,
    });
  }

  if (!hasEditAccess) {
    return t("course:no_creation_permission_tooltip");
  }

  return defaultTooltip;
};

const getCardDropdownOptions = ({
  t,
  type,
  attachmentType,
  isShared,
  itemDepth,
  sectionsCount,
  maxChildDepth,
  isExpanded,
  showExpandCollapseAllOption,
  assessmentType,
  curriculumType,
  hasEditAccess,
  hasClasses,
  hasStudents,
  hasSharingPermission,
  isTermExistsForCurrentLearningCourse,
  academicTerm,
  assessmentLabel,
  isBlueprintCourse,
  isLocked = false,
  hasLockedChildren = false,
  hasLockedAcademicTermChildren = false,
  isPreviousAcademicYearSelected = false,
  isUniversalParentEnabled = false,
}) => {
  const enhancedUnitPlanPrint = isUnitFlowPrintEnabled();
  const isProSchool = getIsProSchool();
  const moveToSectionOption = getMoveToSectionOption({
    t,
    itemType: type,
    itemDepth,
    maxChildDepth,
    sectionsCount,
    hasEditAccess,
    isUniversalParentEnabled,
  });

  const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(
    academicTerm,
    assessmentType
  );
  const isUpdateActionsLocked = !isBlueprintCourse && isLocked;
  const isDeleteBlockedByLockedChildren =
    !isBlueprintCourse && hasLockedChildren;

  switch (type) {
    case "UNIT_PLAN": {
      return _.compact([
        hasEditAccess && {
          key: "UNIT_EDIT",
          label: t("common:edit"),
          icon: <PencilLineOutlined />,
          disabled: isUpdateActionsLocked,
          disabledTooltip: t("course:locked_item_edit_restriction_tooltip", {
            entity: t("common:unit"),
          }),
          suffix: isUpdateActionsLocked ? (
            <LockFilled variant="subtle" size="xxx-small" />
          ) : null,
        },
        {
          key: "UNIT_VIEW",
          label: t("common:view"),
          icon: <EyeOutlined />,
        },

        !isBlueprintCourse &&
          hasSharingPermission &&
          !isPreviousAcademicYearSelected && {
            key: "SHARE_SETTINGS_UNIT",
            label: isShared
              ? t("course:edit_share_settings")
              : t("course:custom_share_settings"),
            icon: <ShareCurveOutlined />,
            disabled: !hasClasses || !hasStudents,
            disabledTooltip: getDisabledTooltipWithPrecedence({
              t,
              hasClasses,
              hasStudents,
              entityType: "sharing",
            }),
          },

        hasEditAccess && {
          key: "UNIT_DUPLICATE",
          label: t("common:duplicate"),
          icon: <CopyOutlined />,
          disabled: hasLockedAcademicTermChildren,
          disabledTooltip: t(
            "course:you_cannot_duplicate_unit_since_it_has_locked_items"
          ),
        },

        isExpanded
          ? {
              key: "COLLAPSE_ALL_SECTIONS",
              label: showExpandCollapseAllOption
                ? t("classMaterials:collapse_all_sections")
                : t("common:collapse"),
              icon: <CaretOpenedFilled />,
            }
          : {
              key: "EXPAND_ALL_SECTIONS",
              label: showExpandCollapseAllOption
                ? t("classMaterials:expand_all_sections")
                : t("common:expand"),
              icon: <CaretClosedFilled />,
            },

        enhancedUnitPlanPrint
          ? {
              key: "custom_print",
              label: t("common:download_planner"),
              icon: <PrintOutlined />,
              isSubMenu: true,
              options: [
                {
                  key: "quick_download",
                  label: t("common:quick_download"),
                  subText: isBlueprintCourse
                    ? t("common:default_download_subtext_for_blueprint")
                    : t("common:default_download_subtext"),
                },
                {
                  key: "custom_download",
                  label: t("common:custom_download"),
                  subText: t("common:custom_download_subtext"),
                },
              ],
            }
          : {
              icon: <PrintOutlined />,
              key: "UNIT_PRINT",
              label: t("common:print"),
            },

        !isBlueprintCourse &&
          hasSharingPermission &&
          !isPreviousAcademicYearSelected && {
            key: "UNIT_VISIBILITY",
            label: t("course:manage_unit_planner_visibility"),
            icon: <PageFoldPortraitOutlined />,
          },

        hasEditAccess && {
          key: "UNIT_DELETE",
          label: t("common:delete"),
          icon: <DeleteOutlined />,
          disabled:
            isUpdateActionsLocked ||
            isDeleteBlockedByLockedChildren ||
            hasLockedAcademicTermChildren,
          disabledTooltip: isUpdateActionsLocked
            ? t("course:locked_item_delete_restriction_tooltip", {
                entity: t("common:unit"),
              })
            : isDeleteBlockedByLockedChildren
            ? t("course:locked_children_item_delete_restriction_tooltip", {
                entity: t("common:unit"),
              })
            : hasLockedAcademicTermChildren
            ? t("course:you_cannot_delete_parent_since_it_has_locked_items", {
                parentEntityLabel: t("common:unit"),
              })
            : t("course:no_creation_permission_tooltip"),
          suffix:
            isUpdateActionsLocked || isDeleteBlockedByLockedChildren ? (
              <LockFilled variant="subtle" size="xxx-small" />
            ) : null,
          isDestructive: true,
        },
      ]);
    }
    case "FOLDER": {
      return _.compact([
        hasEditAccess && {
          key: "SECTION_RENAME",
          label: t("classMaterials:edit_section_title"),
          icon: <TextTOutlined />,
          disabled: isUpdateActionsLocked,
          disabledTooltip: t("course:locked_item_edit_restriction_tooltip", {
            entity: t("common:folder"),
          }),
          suffix: isUpdateActionsLocked ? (
            <LockFilled variant="subtle" size="xxx-small" />
          ) : null,
        },
        ...(isBlueprintCourse ||
        !hasSharingPermission ||
        isPreviousAcademicYearSelected
          ? []
          : [
              {
                key: "SHARE_SETTINGS_SECTION",
                label: isShared
                  ? t("course:edit_share_settings")
                  : t("course:custom_share_settings"),
                icon: <ShareCurveOutlined />,
                disabled: !hasClasses || !hasStudents,
                disabledTooltip: getDisabledTooltipWithPrecedence({
                  t,
                  hasClasses,
                  hasStudents,
                  entityType: "sharing",
                }),
              },
            ]),
        isExpanded
          ? {
              key: "COLLAPSE_ALL_SECTIONS",
              label: showExpandCollapseAllOption
                ? t("classMaterials:collapse_all_sections")
                : t("common:collapse"),
              icon: <CaretOpenedFilled />,
            }
          : {
              key: "EXPAND_ALL_SECTIONS",
              label: showExpandCollapseAllOption
                ? t("classMaterials:expand_all_sections")
                : t("common:expand"),
              icon: <CaretClosedFilled />,
            },
        ...moveToSectionOption,
        hasEditAccess && {
          key: "SECTION_DELETE",
          label: t("common:delete"),
          icon: <DeleteOutlined />,
          disabled:
            isUpdateActionsLocked ||
            isDeleteBlockedByLockedChildren ||
            hasLockedAcademicTermChildren,
          disabledTooltip: isUpdateActionsLocked
            ? t("course:locked_item_delete_restriction_tooltip", {
                entity: t("common:folder"),
              })
            : isDeleteBlockedByLockedChildren
            ? t("course:locked_children_item_delete_restriction_tooltip", {
                entity: t("common:folder"),
              })
            : t("course:you_cannot_delete_parent_since_it_has_locked_items", {
                parentEntityLabel: t("common:folder"),
              }),
          isDestructive: true,
          suffix:
            isUpdateActionsLocked || isDeleteBlockedByLockedChildren ? (
              <LockFilled variant="subtle" size="xxx-small" />
            ) : null,
        },
      ]);
    }

    case "FILE": {
      const isLink = attachmentType === "LINK";
      const isNote = attachmentType === "NOTE";

      return [
        ...(isNote && hasEditAccess
          ? [
              {
                key: "NOTE_EDIT",
                label: t("common:edit"),
                icon: <PencilLineOutlined />,
                disabled: isUpdateActionsLocked,
                disabledTooltip: t(
                  "course:locked_item_edit_restriction_tooltip",
                  {
                    entity: t("common:note"),
                  }
                ),
                suffix: isUpdateActionsLocked ? (
                  <LockFilled variant="subtle" size="xxx-small" />
                ) : null,
              },
            ]
          : []),
        ...(isLink && hasEditAccess
          ? [
              {
                key: "EDIT_LINK",
                label: t("common:edit"),
                icon: <PencilLineOutlined />,
                disabled: isUpdateActionsLocked,
                disabledTooltip: t(
                  "course:locked_item_edit_restriction_tooltip",
                  {
                    entity: t("common:link"),
                  }
                ),
                suffix: isUpdateActionsLocked ? (
                  <LockFilled variant="subtle" size="xxx-small" />
                ) : null,
              },
            ]
          : []),
        ...(!isLink && !isNote && hasEditAccess
          ? [
              {
                key: "FILE_RENAME",
                label: t("common:rename"),
                icon: <PencilLineOutlined />,
                disabled: isUpdateActionsLocked,
                disabledTooltip: t(
                  "course:locked_item_edit_restriction_tooltip",
                  {
                    entity: t("common:resource_label"),
                  }
                ),
                suffix: isUpdateActionsLocked ? (
                  <LockFilled variant="subtle" size="xxx-small" />
                ) : null,
              },
            ]
          : []),
        {
          key: "FILE_VIEW",
          label: t("common:view"),
          icon: <EyeOutlined />,
        },
        ...(isBlueprintCourse ||
        !hasSharingPermission ||
        isPreviousAcademicYearSelected
          ? []
          : [
              {
                key: "SHARE_SETTINGS_RESOURCE",
                label: isShared
                  ? t("course:edit_share_settings")
                  : t("course:custom_share_settings"),
                icon: <ShareCurveOutlined />,
                disabled: !hasClasses || !hasStudents,
                disabledTooltip: getDisabledTooltipWithPrecedence({
                  t,
                  hasClasses,
                  hasStudents,
                  entityType: "sharing",
                }),
              },
            ]),
        ...(hasEditAccess
          ? [
              {
                key: "FILE_DUPLICATE",
                label: t("common:create_a_duplicate"),
                icon: <AddToLibraryOutlined />,
              },
            ]
          : []),
        ...moveToSectionOption,
        ...(!isLink && !isNote
          ? [
              {
                key: "FILE_DOWNLOAD",
                label: t("common:download"),
                icon: <DownloadOutlined />,
              },
            ]
          : []),
        ...(hasEditAccess
          ? [
              {
                key: "FILE_DELETE",
                label: t("common:delete"),
                icon: <DeleteOutlined />,
                disabled: isUpdateActionsLocked,
                disabledTooltip: t(
                  "course:locked_item_delete_restriction_tooltip",
                  {
                    entity: isNote
                      ? t("common:note")
                      : isLink
                      ? t("common:link")
                      : t("common:resource_label"),
                  }
                ),
                suffix: isUpdateActionsLocked ? (
                  <LockFilled variant="subtle" size="xxx-small" />
                ) : null,
                isDestructive: true,
              },
            ]
          : []),
      ];
    }

    case "ASSESSMENT": {
      return _.compact([
        hasEditAccess && {
          key: "ASSESSMENT_EDIT",
          label: t("common:edit"),
          icon: <PencilLineOutlined />,
          disabled: isUpdateActionsLocked || !isGradingPeriodUnlocked,
          disabledTooltip: getDisabledTooltipForUpdations({
            t,
            isUpdateActionsLocked,
            isGradingPeriodUnlocked,
            entityLabel: assessmentLabel,
            actionLabel: t("common:edit"),
          }),
          suffix: isUpdateActionsLocked ? (
            <LockFilled variant="subtle" size="xxx-small" />
          ) : null,
        },
        {
          key: "ASSESSMENT_VIEW",
          label: t("common:view"),
          icon: <EyeOutlined />,
        },
        ...(isBlueprintCourse ||
        isProSchool ||
        !hasSharingPermission ||
        isPreviousAcademicYearSelected
          ? []
          : [
              {
                key: "ASSESSMENT_ASSIGN",
                label: isShared
                  ? t("classRoom:edit_assign_settings")
                  : t("common:assign"),
                icon: <UserTickOutlined />,
                disabled:
                  !hasClasses ||
                  !hasStudents ||
                  !isGradingPeriodUnlocked ||
                  !isTermExistsForCurrentLearningCourse,
                disabledTooltip: getDisabledTooltipWithPrecedence({
                  t,
                  hasClasses,
                  hasStudents,
                  isGradingPeriodUnlocked,
                  isTermExistsForCurrentLearningCourse,
                  assessmentLabel,
                  actionLabel: isShared
                    ? t("classRoom:edit_assign_settings")
                    : t("common:assign"),
                  entityType: "assigning",
                }),
              },
            ]),
        hasEditAccess && {
          key: "FILE_DUPLICATE",
          label: t("common:create_a_duplicate"),
          icon: <AddToLibraryOutlined />,
          disabled: !isGradingPeriodUnlocked,
          disabledTooltip: getDisabledTooltipForUpdations({
            t,
            isGradingPeriodUnlocked,
            entityLabel: assessmentLabel,
            actionLabel: t("common:duplicate"),
          }),
        },
        {
          icon: <PrintOutlined />,
          key: "ASSESSMENT_PRINT",
          label: t("common:print"),
        },
        ...moveToSectionOption,
        hasEditAccess && {
          key: "CHANGE_TASK",
          label: t("common:change_task_type"),
          disabled:
            isUpdateActionsLocked ||
            !isGradingPeriodUnlocked ||
            _.includes(
              [ASSESSMENT_TYPE_WORKSHEET, ASSESSMENT_TYPE_AI_TUTOR],
              assessmentType
            ),
          disabledTooltip: getDisabledTooltipForUpdations({
            t,
            isUpdateActionsLocked,
            isGradingPeriodUnlocked,
            entityLabel: assessmentLabel,
            actionLabel: t("common:change_task_type"),
            defaultTooltip: t(
              "classRoom:change_task_type_dropdown_disabled_tooltip"
            ),
          }),
          icon: <ReloadArrowOutlined variant="subtle" />,
          shouldHide:
            curriculumType === CURRICULUM_TYPE_PYP &&
            !ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP),
          suffix: isUpdateActionsLocked ? (
            <LockFilled variant="subtle" size="xxx-small" />
          ) : null,
        },
        hasEditAccess && {
          key: "ASSESSMENT_DELETE",
          label: t("common:delete"),
          icon: <DeleteOutlined />,
          disabled: isUpdateActionsLocked || !isGradingPeriodUnlocked,
          disabledTooltip: getDisabledTooltipForUpdations({
            t,
            isUpdateActionsLocked,
            isGradingPeriodUnlocked,
            entityLabel: assessmentLabel,
            actionLabel: t("common:delete"),
            isDelete: true,
          }),
          isDestructive: true,
          suffix: isUpdateActionsLocked ? (
            <LockFilled variant="subtle" size="xxx-small" />
          ) : null,
        },
      ]);
    }
  }

  return [];
};

export const getCardDropdownOptionsMemoized = getMemoizedLangFunction(
  getCardDropdownOptions
);

const getStudentStatusFilterOptions = ({ t }) => {
  const filteredOptions = [
    {
      value: "TODO",
      label: t("classRoom:todo"),
      options: [
        ...PUBLISHED_STUDENT_ASSIGNMENT_STATUS,
        ...PUBLISHED_STUDENT_ASSIGNMENT_LOCKING_SUBMISSION_STATUS,
        {
          ...ASSIGNMENT_STATE_TABS.SCHEDULED,
          label: ASSIGNMENT_STATE_TABS.SCHEDULED.studentLabel,
        },
      ],
    },
    {
      value: "DONE",
      label: t("common:done"),
      options: [...getArchivedStudentAssignmentStatus()],
    },
  ];

  _.forOwn(filteredOptions, value => {
    value.options = _.map(value.options, ({ label, value }) => ({
      key: value,
      value,
      label: t(label),
    }));
  });

  return filteredOptions;
};

export const getStudentStatusFilterOptionsMemoized = getMemoizedLangFunction(
  getStudentStatusFilterOptions
);

export const getStudentListOptions = ({
  students,
  defaultStudentNameOrderPreference,
}) =>
  _.map(students, student => ({
    value: student.id,
    label: getFormattedStudentName({
      student: student,
      isFormattedNameV2: true,
      defaultStudentNameOrderPreference,
    }),
    isArchived: student.isArchived,
    thumbnail: student.profileImage,
  }));

export const SHARE_ACTIONS = {
  SHARE: "SHARE",
  UNSHARE: "UNSHARE",
};

export const SHARING_STATES = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
};

export const GENERIC_ITEM_TYPES = {
  UNIT_PLAN: "UNIT_PLAN",
  FOLDER: "FOLDER",
  ASSESSMENT: "ASSESSMENT",
  RESOURCE: "RESOURCE",
};

export const ITEM_TYPES = {
  UNIT_PLAN: "UNIT_PLAN",
  FOLDER: "FOLDER",
  LINK: "LINK",
  NOTE: "NOTE",
  FILE: "FILE",
  LE: "LE",
  ASSESSMENT: "ASSESSMENT",
  ITEM: "ITEM",
  ITEMS: "ITEMS",
};

export const TOAST_ACTION_LABELS = {
  ADDED: "toastMsgs:added",
  CREATED: "toastMsgs:created",
  DELETED: "toastMsgs:deleted",
  REMOVED: "toastMsgs:removed",
  MOVED: "toastMsgs:moved",
  CLEARED: "toastMsgs:cleared",
  UPDATED: "toastMsgs:updated",
  RENAMED: "common:renamed",
  UPLOADED: "toastMsgs:uploaded",
  IMPORTED: "toastMsgs:imported",
  DUPLICATED: "toastMsgs:duplicated",
  ASSIGNED: "common:assigned",
};

export const getIsResourceShared = ({ orgResource }) => {
  if (_.isEmpty(orgResource)) return null;
  return (
    orgResource.state === SHARING_STATES.PUBLISHED ||
    !_.isEmpty(orgResource.sharedDetails)
  );
};

const getSharedSettingDiff = ({
  itemSharedDetails = [],
  sharedDetails = [],
}) => {
  const diff = {
    classes: [],
    students: {},
  };

  let isSubset = true;

  const itemSharingMapping = _.reduce(
    itemSharedDetails,
    (acc, cls) => {
      acc[cls.class.id] = _.map(cls.students, "id");
      return acc;
    },
    {}
  );

  const sharingMapping = _.reduce(
    sharedDetails,
    (acc, cls) => {
      acc[cls.class.id] = _.map(cls.students, "id");
      return acc;
    },
    {}
  );

  // Check if itemSharingMapping is subset of sharingMapping
  for (const key in itemSharingMapping) {
    if (!_.has(sharingMapping, key)) {
      // Class is not present in sharingMapping
      diff.classes.push(key);
      isSubset = false;
    } else {
      const itemStudents = itemSharingMapping[key];
      const students = sharingMapping[key];
      const difference = _.difference(itemStudents, students);
      if (!_.isEmpty(difference)) {
        // Students are not same
        diff.students[key] = difference;
        isSubset = false;
      }
    }
  }

  return { isSubset, diff };
};

export const getIsResourceSharedRecursivelyWithSameSettings = ({
  sharedDetails: _sharedDetails = [],
  orgResource,
  items,
  isParentCheck = false,
}) => {
  const isShared = getIsResourceShared({ orgResource });
  const resourceSharedDetails = _.get(orgResource, "sharedDetails", []);
  const sharedDetails = _.isEmpty(_sharedDetails)
    ? resourceSharedDetails
    : _sharedDetails;

  let isSharedWithSameSettings = true;
  let diffObj = {};

  if (!_.isEmpty(_sharedDetails)) {
    // While checking share details wrt parent, parent's sharedDetails will be the superset
    if (isParentCheck) {
      diffObj = getSharedSettingDiff({
        itemSharedDetails: sharedDetails,
        sharedDetails: resourceSharedDetails,
      });

      diffObj.parentType = _.get(orgResource, "resourceType", "FOLDER");
    } else {
      diffObj = getSharedSettingDiff({
        itemSharedDetails: resourceSharedDetails,
        sharedDetails,
      });
    }

    isSharedWithSameSettings = diffObj.isSubset;
  }

  if (isShared && isSharedWithSameSettings) {
    const parent = _.find(items, { id: _.get(orgResource, "parent.id") });
    if (parent) {
      return getIsResourceSharedRecursivelyWithSameSettings({
        orgResource: parent,
        sharedDetails,
        items,
        isParentCheck: true,
      });
    } else return true;
  } else
    return {
      ...diffObj,
      isSubset: false,
      isVisible: false,
    };
};

export const getEditableClasses = ({ associatedClasses, learningCourseId }) => {
  const editableClasses = _.filter(associatedClasses, cls => {
    const isVisible = isClassModuleVisible({
      classId: cls.id,
      permission: CAN_ASSIGN_COURSE_CONTENT_PERMISSION,
      learningCourseId,
    });
    return isVisible;
  });

  return editableClasses;
};

export const getIsItemLocked = ({ item }) => {
  const isItemLocked = _.get(item, "lockingInfo.isLocked", false);
  const isInnerItemLocked = _.get(item, "item.lockingInfo.isLocked", false);
  return isItemLocked || isInnerItemLocked;
};

export const getHasConflict = ({ item }) => {
  const hasCourseConflict = _.get(
    item,
    "isSyncedWithAllTeacherCourseV2.isConflictExists",
    false
  );

  const hasInnerCourseConflict = _.get(
    item,
    "item.isSyncedWithAllTeacherCourseV2.isConflictExists",
    false
  );

  return hasCourseConflict || hasInnerCourseConflict;
};

export const getHasLockedChildren = ({ item, resourceRelationConfig }) => {
  const itemId = _.get(item, "id", null);
  if (!itemId) return false;

  const childrenId = _.get(
    resourceRelationConfig,
    `childrenConfig.${itemId}`,
    []
  );
  const resourcesConfig = _.get(resourceRelationConfig, "resourcesConfig", {});

  return _.some(childrenId, childId => {
    const childItem = _.get(resourcesConfig, childId, {});
    return getIsItemLocked({ item: childItem });
  });
};

export const getHasUnlockedChildren = ({ item, resourceRelationConfig }) => {
  const itemId = _.get(item, "id", null);
  if (!itemId) return false;

  const childrenId = _.get(
    resourceRelationConfig,
    `childrenConfig.${itemId}`,
    []
  );
  const resourcesConfig = _.get(resourceRelationConfig, "resourcesConfig", {});

  return _.some(childrenId, childId => {
    const childItem = _.get(resourcesConfig, childId, {});
    return !getIsItemLocked({ item: childItem });
  });
};

export const getHasLockedAcademicTermChildren = ({
  item,
  resourceRelationConfig,
}) => {
  const itemId = _.get(item, "id", null);
  if (!itemId) return false;

  const childrenId = _.get(
    resourceRelationConfig,
    `childrenConfig.${itemId}`,
    []
  );
  const resourcesConfig = _.get(resourceRelationConfig, "resourcesConfig", {});
  return _.some(childrenId, childId => {
    const childItem = _.get(resourcesConfig, childId, {});
    const academicTerm = _.get(childItem, "item.academicTerm");
    const assessmentType = _.get(childItem, "item.assessmentType.value");
    return !getIsGradingPeriodUnlocked(academicTerm, assessmentType);
  });
};
